import { AuthenticationService } from "./../../servicios/authentication.service";
import {Component,OnInit,EventEmitter,ViewChild,Input,Output,} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConsultaLecturasService } from "../../servicios/consulta-lecturas.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import {ConsultaLecturas, CatRutas,CatUsuarios,ConsultaLecturasInput,json_lecturas,ObtenerUsuarioPorCargoInput,PadronAguaGeneralesInput,PadronAguaGenerales,Consumos,CatVencimientos_,EstadoCuentaInformacionInput,Aguas, HistoricoConsumosCanceladosInput,HistoricoConsumosCancelados,ConsultaHistoricoMigradoInput,CatTipoServicios,RegistroBitacoraInput,HistoricoLecturasInput,Config,AuxJasper,ParametroJasper, FCatVencimientosInput, Medidores,} from "../../entidades/entidades";
import { CatRutasService } from "../../servicios/cat-rutas.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { CatAnomaliasService } from "../../servicios/cat-anomalias.service";
import { ActualizaLecturasService } from "../../servicios/actualiza-lecturas.service";
import { CatTipoUsosService } from "../../servicios/cat-tipo-usos.service";
import { CatTipoServiciosService } from "../../servicios/cat-tipo-servicios.service";
import { CatDiametroTomasService } from "../../servicios/cat-diametro-tomas.service";
import { CatTipoPeriodosService } from "../../servicios/cat-tipo-periodos.service";
import { CatTipoIngresoService } from "../../servicios/cat-tipo-ingreso.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
import { ConfirmationService } from "primeng/api";
import { MessageService } from "primeng/api";
import { CatVencimientos_Service } from "../../servicios/cat-vencimientos.service";
import { EstadoCuentaInformacionService } from "../../servicios/estado-cuenta-informacion.service";
import { AguasService } from "../../servicios/aguas.service";
import { PadronAguaGeneralesService } from "../../servicios/padron-agua-generales.service";
import { HistoricoConsumosCanceladosService } from "../../servicios/historico-consumos-cancelados.service";
import { CertificadoNoAdeudoService } from "../../servicios/certificado-no-adeudo.service";
import { VencimientosLecturaComponent } from "../../componentes/vencimientos-lectura/vencimientos-lectura.component";
import { RegistroBitacoraService } from "../../servicios/registro-bitacora.service";
import { GeneraPeriodoSiguienteService } from "../../servicios/genera-periodo-siguiente.service";
import { MuestraImageneservice } from "../../servicios/muestra-imagenes.service";
import { SelectItem, MenuItem } from "primeng/api";
import { Table } from "primeng/table";
import { HistoricoLecturasService } from "app/servicios/historico-lecturas.service";
import { FCatVencimientosService } from "app/servicios/f-cat-vencimientos.service";
import { CargoDetallesGridComponent } from "../cargo-detalles-grid/cargo-detalles-grid.component";
import { CatTipoObservacionService } from "app/servicios/cat-tipo-observacion.service";
import { log } from "console";


declare let $: any;

@Component({
  selector: "app-consulta-lecturas",
  templateUrl: "./consulta-lecturas.component.html",
  styleUrls: ["./consulta-lecturas.component.css"]
})
export class ConsultaLecturasComponent implements OnInit {
  [x: string]: any;
  @ViewChild('dt1') dt1: Table | undefined; // Referencia a la tabla

  public auxJasper: AuxJasper;
  muestraMensaje = new MuestraMensaje();
  busquedaForm: FormGroup;
  userform: FormGroup;
  public progressBar = false;
  public esSimulacion: boolean = false;
  msgs: string;
  columnasTabla: any[];
  columnasTablaHistorico: any[];
  public usuarios: ObtenerUsuarioPorCargoInput;
  public registroBitacora = new RegistroBitacoraInput();
  public catRutas: CatRutas[] = [];
  public catUsuaios: CatUsuarios[] = [];
  contrato: number;
  public tableWidget: any;
  public usuario: any;
  public cuentaSeleccionada: Aguas;
  public datosBusqueda: ConsultaLecturasInput;
  public consultaLectura: ConsultaLecturas[];
  public consultaLecturaFlag: boolean = true;
  public consultaLecturaRow: ConsultaLecturas[];
  public consultaLecturaSimulada: ConsultaLecturas;
  itemsMenu: MenuItem[];
  public guardar: boolean;
  public load: boolean = false;
  public CapturaMasiva: boolean = true;
  public cerrarRutaEdicion: boolean = false;
  public consumos: Consumos;
  public longitudTabla: number;
  public saveSimulacion: boolean;
  @Output()ImprimeRecepcionEmit: EventEmitter<ConsultaLecturasInput>;
  @Output()ImprimeRecibosEmit: EventEmitter<ConsultaLecturasInput>;
  private tieneAdeudo: boolean = false;
  public lecturaTable: ConsultaLecturas[];
  critical: boolean = false;
  vallecturas: boolean = false;
  cargosDialog: boolean = false;
  cargosDialogEspecial : boolean = false;
  showProgressBar: boolean = true;
  display: boolean = false;
  muestraHistoricoConsumos: boolean = false;
  historicoConsumosCanceldos: HistoricoConsumosCancelados;
  ContadorModificados: number;
  ContadorNoModificados: number;
  estausFiscalizacion: PadronAguaGenerales[];
  estausFuscalizacionInput: PadronAguaGeneralesInput;
  public cuentaAgua: number;
  public derivada: number;
  displayHistoricoMigracion: boolean = false;
  displayLecturas: boolean = false;
  public consultaHistoricoMigradoInput$ =
    new EventEmitter<ConsultaHistoricoMigradoInput>();

  //VARIABLE DE BLOQUEOY VARIABLE PARA IDENTIFICAR SI ES CUOTA FIJA
  public bloqueoActivo: boolean = false;
  public esCuotaFija: boolean = false;
  @ViewChild(CargoDetallesGridComponent, { static: false }) chilCargoDetallesGridComponent;
  aplicaCritica : boolean = null;
  @ViewChild(VencimientosLecturaComponent, { static: false }) childVenciminetoLectura;

  clonedConsultaLecturas: { [s: string]: ConsultaLecturas } = {};
  json_lecturas: json_lecturas;
  id_agua: number;
  public catalogoAnio: CatVencimientos_[] = [];
  public catalogoBimestres: CatVencimientos_[] = [];
  public nuevoAnio: CatVencimientos_[] = [];
  public nuevoBim: CatVencimientos_[] = [];
  public anioSeleccionadoIni: CatVencimientos_;
  public anioSeleccionadoFin: CatVencimientos_;
  public bimSeleccionadoIni: CatVencimientos_;
  public bimSeleccionadoFin: CatVencimientos_;
  confirmaAnio: boolean = false;
  public tipoServicioGeneral: CatTipoServicios;
  displayHistoricoMiracion: boolean = false;
  first: number = 0;
  first1: number = 0;
  cols: any[];
  anomalias: SelectItem[];
  tipoUsos: SelectItem[];
  tipoServicio: SelectItem[];
  diametroToma: SelectItem[];
  tipoPeriodo: SelectItem[];
  tipoIngreso: SelectItem[];
  estatus: SelectItem[];
  usuarioLecturista: SelectItem[];
  idUsuarioLecturista: number;
  fechaLectura: Date;
  estatusFiltrados: SelectItem[];
  descripcionObservacion:SelectItem[];
  consumo: number;
  totales: number = 0;
  items: MenuItem[] | undefined;
  buttonCritico : boolean = false;
  numsRows: any[] = [];
  imageDialog: boolean = false;
  responsiveOptions: any[] | undefined;
  imagenes: any[] | undefined;
  flagRecalcular: boolean = false;
  tamanio: number;
  public observacionMasivaTexto : string;
  id_tipo_periodo: number;
  totalRegistro: number = 0;
  
  @Input("esEstadoMasivo") esEstadoMasivo: boolean = false;
  @ViewChild(VencimientosLecturaComponent, { static: false })
  childVencimientosLecturaComponent;
  @Input("consultaLecturasInput") consultaLecturasInput: ConsultaLecturasInput;
  @Input("captura") captura: boolean = false;
  @Input("simulacion") simulacion: boolean = false;
  @Input("correciones") correciones: boolean = false;
  @Output("consultaLecturasOutput") consultaLecturasOutput: EventEmitter<ConsultaLecturas[]>;
  @Output("calculaLecturasOutput") calculaLecturasOutput: EventEmitter<ConsultaLecturasInput>;
  @Output()datosCargados =  new EventEmitter<number>(); 

  public historicoLecturasInput$ = new EventEmitter<HistoricoLecturasInput>();
  public cAgua: number;
  public iAmbiente: number;
  public zonaAguaId: any;
  public anio: any;
  public periodo_parcialidad: any ;
  public colonia: any;
  public id_usuario_lecturista: any ;
  public siguienteParcial : number;
  historicoLecturasInput: HistoricoLecturasInput;
  public isPdfViewerVisible: boolean;
  public cambioEstatusMasivo: boolean = false;
  public usos : SelectItem[] = [];
  public disabledBotton: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private consultaLecturasService: ConsultaLecturasService,
    private route: ActivatedRoute,
    private registroBitacoraService: RegistroBitacoraService,
    private catUsuariosService: CatUsuariosService,
    private catRutasService: CatRutasService,
    private catAnomaliasService: CatAnomaliasService,
    private actualizaLecturas: ActualizaLecturasService,
    private confirmationService: ConfirmationService,
    private confirmationServiceM: ConfirmationService,
    private catTipoUsosService: CatTipoUsosService,
    private catTipoServiciosService: CatTipoServiciosService,
    private catDiametroTomasService: CatDiametroTomasService,
    private catTipoPeriodosService: CatTipoPeriodosService,
    private catTipoIngresoService: CatTipoIngresoService,
    private catEstatusService: CatEstatusService,
    private obtenerUsuarioPorCargoService: ObtenerUsuarioPorCargoService,
    private messageService: MessageService,
    private authenticationService: AuthenticationService,
    private vencimientosLecturaService: CatVencimientos_Service,
    private estadoCuentaInformacionService: EstadoCuentaInformacionService,
    private aguasService: AguasService,
    private historicoConsumosCanceladosService: HistoricoConsumosCanceladosService,
    private generaPeriodoSiguienteService: GeneraPeriodoSiguienteService,
    private padronAguaGeneralesService: PadronAguaGeneralesService,
    private certificadoNoAdeudoService: CertificadoNoAdeudoService,
    private historicoLecturasService: HistoricoLecturasService,
    private fCatVencimientos:FCatVencimientosService,
    private muestraImageneservice: MuestraImageneservice,
    private observacionesDescripcion: CatTipoObservacionService
  ) {
    this.consultaLecturasOutput = new EventEmitter();
    this.ImprimeRecepcionEmit = new EventEmitter();
    this.ImprimeRecibosEmit = new EventEmitter();
    this.calculaLecturasOutput = new EventEmitter();
  }

  async ngOnInit() { 
    this.getCatRutas();
    this.getCatUsuarios();
    await this.catEstatusAll();
    this.catEstatusLecturista();
    this.getAnios();
    this.getBimestres();
    this.catTipoUsoAll();
    this.catTipoServiciosAll();
	  await this.getCatAnomalias();
    await this.getCatObservaciones();
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue.id;

    if (this.simulacion == true) {
      this.columnasSimulacion();
    } else if (this.captura == true) {
      this.columnas();
    } else if (this.correciones == true) {
      this.columnasCorreciones();
    }

    this.tipoServicioGeneral = new CatTipoServicios();

    let config: Config = JSON.parse(localStorage.getItem("config"));

    this.iAmbiente = config.IdAmbiente;

    this.responsiveOptions = [
        { breakpoint: '1400px', numVisible: 3,numScroll: 3 },
        { breakpoint: '1220px', numVisible: 2, numScroll: 2 },
        { breakpoint: '1100px', numVisible: 1, numScroll: 1 },
    ];

    this.items = [
      {  
        label: "File",
        items: [
          { label: "Critica", icon: "pi-file-o", command: () => this.imprimirCritical()},
        ],
      },
      {
        label: "File",
        items: [
          { label: "Imprimir", icon: "pi-file-o", command: () => this.imprimirLectura("pdf")},
        ],
      },
    ];
      
	  await this.getEstatusFiltrados();
  }

  async columnas() {

    this.opcionesBotones();

    // Columnas para la captura de lecturas y validacion
    //captura
    this.columnasTabla = [
      { field: "Checkbox", header: "", styleHeader: "width: 30px;",  showOn: "captura"  },
      {field: "operacion",header: "",ordenar: false,styleHeader: "width: 90px;",},];
      
      this.columnasTabla .push(
        { field: "fechaLectura", header: "Fecha Lectura", ordenar: false, styleHeader: "width: 80px;" },
        { field: "consecutivo",header: "Consec.",ordenar: true,styleHeader: "width: 60px",},
        { field: "cuenta", header: "Contrato", ordenar: false, styleHeader: "width: 70px;" },
        { field: "idUso", header: "Uso", ordenar: false, styleHeader: "width: 100px;" },
        { field: "serie", header: "Serie", ordenar: false, styleHeader: "width: 90px;" },
        { field: "idEstatus", header: "Estatus", ordenar: false, styleHeader: "width: 90px;" },
        { field: "consumoAnt", header: "Csmo Ant", ordenar: false, styleHeader: "width: 70px;" },
        { field: "consumoPu", header: "Csmo Pu", ordenar: false, styleHeader: "width: 60px;" },
        { field: "consumoPr", header: "Csmo Pr", ordenar: false, styleHeader: "width: 60px;" },
        { field: "lecturaIni", header: "L. Inicial", ordenar: false, styleHeader: "width: 60px;" },
        { field: "lecturaFin", header: "L. Final", ordenar: false, styleHeader: "width: 60px;" },
        // { field: "m3Original", header: "M3 Original", ordenar: false, styleHeader: "width: 60px;" },
        { field: "consumo", header: "Csmo", ordenar: false, styleHeader: "width: 60px;" },
        { field: "totalizador", header: "Totalizador", ordenar: false, styleHeader: "width: 90px;" },
        { field: "validacion", header: "Validacion", ordenar: false, styleHeader: "width: 90px;" },
        { field: "idAnomalia", header: "Anomalia", ordenar: false, styleHeader: "width: 100px;" },
        { field: "lecturaCritica", header: "Lectura Critica", ordenar: false, styleHeader: "width: 60px;" },
        { field: "ap_c", header: "Critica", ordenar: false, styleHeader: "width: 60px;" },
        { field: "fechaCritica", header: "Fecha Critica", ordenar: false, styleHeader: "width: 140px;" },
        { field: "idUsuarioLecturista", header: "Lecturista", ordenar: false, styleHeader: "width: 100px;" },
        { field: "observaciones", header: "Observaciones", ordenar: false, styleHeader: "width: 200px;" },
        { field: "consumoPerAnioAnt", header: "Csmo Per Anio Ant", ordenar: false, styleHeader: "width: 70px;" },
        { field: "consumoMin", header: "Csmo Min", ordenar: false, styleHeader: "width: 70px;" },
        { field: "derivada", header: "Padre", ordenar: false, styleHeader: "width: 50px;" },
        { field: "cliente", header: "Cliente", ordenar: false, styleHeader: "width: 190px;" },
        { field: "nombreLocal", header: "Nombre del Local", ordenar: false, styleHeader: "width: 140px;" },
        { field: "colonia", header: "Colonia", ordenar: false, styleHeader: "width: 140px;" },
        { field: "idTipoUso", header: "Tipo Uso", ordenar: false, styleHeader: "width: 100px;" },
        { field: "suma", header: "Monto Adicional", ordenar: false, styleHeader: "width: 5rem;" },
        { field: "abono", header: "Saldo a Favor", ordenar: false, styleHeader: "width: 7rem;" },
        { field: "fechaCobro", header: "Fecha Último Pago", ordenar: false, styleHeader: "width: 10rem;" },
        { field: "validadoFacturacion", header: "Validado Facturación", ordenar: false, styleHeader: "width: 7rem;" },
      );
  }

  async columnasCorreciones() {
    // Columnas correccino de periodos

    this.columnasTabla = [
      { field: "operacion",header: "",ordenar: false,styleHeader: "width: 90px;",},
      { field: "cuenta",header: "Contrato",ordenar: false,styleHeader: "width: 70px;",},
      { field: "idTipoUso", header: "Tipo Uso", ordenar: false, styleHeader: "width: 120px;" },
      //{ field: "derivada",header: "Derivada",ordenar: false,styleHeader: "width: 70px;",},
      { field: "serie", header: "Serie", ordenar: false, styleHeader: "width: 85px;" },
      { field: "idEstatus", header: "Estatus", ordenar: false, styleHeader: "width: 70px;" },
      { field: "lecturaIni", header: "L. Inicial", ordenar: false, styleHeader: "width: 65px;" },
      { field: "lecturaFin", header: "L. Final", ordenar: false, styleHeader: "width: 60px;" },
      { field: "consumo", header: "Consumo", ordenar: false, styleHeader: "width: 70px;" },
      { field: "idAnomalia", header: "Anomalia", ordenar: false, styleHeader: "width: 110px;" },
      { field: "observaciones", header: "Observación Descipción",ordenar: false, styleHeader: "width: 180px;",},
      { field: "anio", header: "Año", ordenar: false, styleHeader: "width: 50px;" },
      { field: "periodoParcialidad", header: "Mes", ordenar: false, styleHeader: "width: 40px;" },
    ];

    if (this.bloqueoActivo == true) {
      this.itemsMenu = [
        {
          label: "Guardar",
          icon: "pi pi-save",
          command: (event) => {
            this.saveSimulacion = false;
            this.muestraMensaje.error(
              "No puedes hacer ninguna corrección a una cuenta con bloqueo.",
              "top",
              "center"
            );
          },
        },
        {
          label: "Refrescar",
          icon: "pi pi-refresh",
          command: (event) => {
            this.showBar();
            this.refrescar(this.datosBusqueda);
          },
        },
        
      ];
    } else {
      this.itemsMenu = [
        {
          label: "Guardar",
          icon: "pi pi-save",
          command: (event) => {
            this.saveSimulacion = false;
            this.confirm();
          },
        },
        {
          label: "Refrescar",
          icon: "pi pi-refresh",
          command: (event) => {
            this.showBar();
            this.refrescar(this.datosBusqueda);
          },
        },
      ];
    }
  }

  async columnasHistorico() {
			 
    this.columnasTablaHistorico = [
      { field: "cuenta", header: "Cuenta", ordenar: false, styleHeader: "width: 80px;" },
      { field: "lecturaFin", header: "Lectura Final11111", ordenar: false, styleHeader: "width: 90px;" },
      { field: "lecturaIni", header: "Lectura Inicial", ordenar: false, styleHeader: "width: 130px;" },
      { field: "consumo", header: "Consumo", ordenar: false, styleHeader: "width: 800px;" },
      { field: "serie", header: "Serie", ordenar: false, styleHeader: "width: 220px;" },
      { field: "anio", header: "Año", ordenar: false, styleHeader: "width: 100px;" },
      { field: "periodoParcialidad", header: "Periodo Parcialidad", ordenar: false, styleHeader: "width: 100px;" },
      { field: "usuario", header: "Usuario Canceló", ordenar: false, styleHeader: "width: 250px;" },
      { field: "tipoUso", header: "Tipo Uso", ordenar: false, styleHeader: "width: 175px;" },
      { field: "tipoServicio", header: "Tipo Servicio", ordenar: false, styleHeader: "width: 175px;" },
      { field: "observaciones", header: "Observaciones", ordenar: false, styleHeader: "width: 350px;" },
    ];
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                    COLUMNAS DE SIMULACIÓN
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async columnasSimulacion() {
    if (this.bloqueoActivo == true) {
      this.itemsMenu = [
        { label: "Guardar", icon: "pi pi-save", command: (event) => { this.saveSimulacion = false; this.confirm(); } },
        { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.showBar(); this.refrescar(this.datosBusqueda); } },
        { label: "Historico Migración", icon: "pi pi-clone", command: (event) => { this.historicoMigracion(); } },

      ];
    } else {
      this.itemsMenu = [
        { label: "Guardar", icon: "pi pi-save", command: (event) => { this.saveSimulacion = false; this.confirm(); } },
        { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.showBar(); this.refrescar(this.datosBusqueda); } },
        { label: "Aplicar", icon: "pi pi-thumbs-up", command: (event) => { this.totales = 0; for (let lecturas of this.consultaLectura) { lecturas.cambio = true; this.totales += lecturas.total; } this.saveSimulacion = true; this.confirm(); } },
        { label: "Cancelar", icon: "pi pi-thumbs-down", command: (event) => { this.saveSimulacion = false; for (let lecturas of this.consultaLectura) { lecturas.cambio = true; lecturas.idEstatus = 4; } this.confirm(); } },
        { label: "Historico Migración", icon: "pi pi-clone", command: (event) => { this.historicoMigracion(); } },
      ];
    }

    this.columnasTabla = [
      { field: "operacion", header: "", ordenar: false, styleHeader: "width: 40px;" },
      { field: "cuenta", header: "Num. Contrato", ordenar: false, styleHeader: "width: 80px;" },
      { field: "derivada", header: "Derivada", ordenar: false, styleHeader: "width: 80px; max-width: 200px;" },
      { field: "serie", header: "Serie", ordenar: false, styleHeader: "width: 100px;" },
      { field: "lecturaIni", header: "Lectura Anterior", ordenar: false, styleHeader: "width: 130px;" },
      { field: "idAnomalia", header: "Anomalia - NO Lectura", ordenar: false, styleHeader: "width: 175px;" },
      { field: "anio", header: "Año", ordenar: false, styleHeader: "width: 80px;" },
      { field: "periodoParcialidad", header: "Periodo", ordenar: false, styleHeader: "width: 100px;" },
      { field: "lecturaFin", header: "Lectura Actual", ordenar: false, styleHeader: "width: 130px;" },
      { field: "idTipoUso", header: "Tipo Uso", ordenar: false, styleHeader: "width: 175px;" },
      { field: "idTipoServicio", header: "Tipo Servicio", ordenar: false, styleHeader: "width: 175px;" },
      { field: "idDiametroToma", header: "Diametro Toma", ordenar: false, styleHeader: "width: 175px;" },
      { field: "idTipoPeriodo", header: "Tipo Periodo", ordenar: false, styleHeader: "width: 175px;" },
      { field: "idTipoIngreso", header: "Tipo Ingreso", ordenar: false, styleHeader: "width: 175px;" },
      { field: "idEstatus", header: "Estatus", ordenar: false, styleHeader: "width: 175px;" },
      { field: "observaciones", header: "Observaciones", ordenar: false, styleHeader: "width: 350px;" },
      { field: "idUsuarioLecturista", header: "Lecturista", ordenar: false, styleHeader: "width: 250px;" },
      { field: "baseConsumo", header: "Base", ordenar: false, styleHeader: "width: 170px;" },
      { field: "drenaje", header: "Servicio Drenaje", ordenar: false, styleHeader: "width: 170px;" },
      { field: "manejo", header: "Manejo y Conducción", ordenar: false, styleHeader: "width: 100px;" },
      { field: "recargos", header: "Recargos", ordenar: false, styleHeader: "width: 100px;" },
      { field: "descuento", header: "Descuentos", ordenar: false, styleHeader: "width: 170px;" },
      { field: "actualizacion", header: "Actualización", ordenar: false, styleHeader: "width: 170px;" },
      { field: "total", header: "Total", ordenar: false, styleHeader: "width: 170px;" },
      { field: "acciones", header: "", ordenar: false, styleHeader: "width: 50px;" },
      { field: "consumoAnt", header: "Consumo Ant", ordenar: true, styleHeader: "width: 150px;" },
      { field: "consumoPu", header: "Consumo Pu", ordenar: true, styleHeader: "width: 150px;" },
      { field: "consumoPr", header: "Consumo Pr", ordenar: true, styleHeader: "width: 150px;" },
      { field: "consumoMin", header: "Consumo Min", ordenar: true, styleHeader: "width: 150px;" },
      { field: "consumoPerAnioAnt", header: "Consumo Per Anio Ant", ordenar: true, styleHeader: "width: 150px;" },
      { field: "fechaLectura", header: "Fecha Lectura", ordenar: true, styleHeader: "width: 150px;" },
      { field: "m3Original", header: "M3 Original", ordenar: true, styleHeader: "width: 150px;" },
      { field: "consumo", header: "Consumo", ordenar: false, styleHeader: "width: 140px;" },
      { field: "validacion", header: "Validacion", ordenar: true, styleHeader: "width: 150px;" },
      { field: "fechaCritica", header: "Fecha Critica", ordenar: true, styleHeader: "width: 150px;" },
      { field: "lecturaCritica", header: "Lectura Critica", ordenar: true, styleHeader: "width: 150px;" },
    ] ;
  }

  ngAfterViewInit() {
			 
    this.initDatatable();
  }
  

  private initDatatable(): void {
			 
    const tabla: any = $("#tablaBuscaTramite");
    this.tableWidget = tabla.DataTable({
      scrollX: true,
      destroy: true,
      filter: false,
    });
  }
  private reInitDatatable(): void {
			 
    this.tableWidget.destroy();
    // this.tableWidget = null;
    setTimeout(() => this.initDatatable(), 0);
  }

  async getCatRutas() {
			 
    let datoRetorno = await this.catRutasService.getAll().toPromise();
    this.catRutas = datoRetorno;
  }
  async getCatUsuarios() {
			 
    try {
      let datoRetorno = await this.catUsuariosService.getAll().toPromise();
      this.catUsuaios = datoRetorno;
      //SE ASIGNA EL USUARIO AL COMBO DE CAJEROS
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
    }
  }

  //============================================================================
  //              Recibe Parametros de busqueda
  //============================================================================
  guardaEstado(estatus: boolean) {
    this.showProgressBar = estatus;
    this.itemsMenu = [];  
    this.guardar = false;
    this.consultaLectura = [];  
  }

  async childBusquedaLectura(buscaLectura: ConsultaLecturasInput) {
    this.datosBusqueda = buscaLectura;
    this.consultaLectura = null;
    this.totalRegistro = 0;
    let ruta  =  this.catRutas.find((x) => x.id == buscaLectura.ruta);
    if (ruta?.dato) {
      this.id_tipo_periodo = Number(JSON.parse(ruta.dato)?.id_tipo_periodo);
    }   
    this.clear();
    this.messageService.clear();
    try {
      !this.showProgressBar
        ? (this.progressBar = false)
        : (this.progressBar = true);

      //============================================================================
      //              Evalua que exista el parametro de IdAgua o IdRuta
      //              Sin ellos no se puede hacer la consulta de las lecturas
      //============================================================================
      if ( this.datosBusqueda.idAgua != null || this.datosBusqueda.ruta != null) {
        //============================================================================
        //              Evalua la existencia del parametro de IdAgua
        //============================================================================
        if (buscaLectura.idAgua != null) {
          let buscaAgua = new EstadoCuentaInformacionInput();
          buscaAgua.idAgua = parseInt(buscaLectura.idAgua);
          const aguas = await this.estadoCuentaInformacionService
            .getBusquedas(buscaAgua)
            .toPromise();
          if (aguas[0]) {
            //===============================================================================
            //          Busca en la tabla de Aguas para saber su estatus, tipo servicio, etc
            //===============================================================================
            this.id_agua = aguas[0].idAgua;

            this.cuentaSeleccionada = await this.aguasService
              .getSingle(this.id_agua)
              .toPromise();

            //===============================================================================
            //          Asigna el tipo de servicio al combo de servicio en la simulacion
            //===============================================================================
            this.tipoServicioGeneral.id =
              this.cuentaSeleccionada.idTipoServicio;

            this.cuentaAgua = aguas[0].cuentaAgua;
            this.derivada = aguas[0].derivada;

            this.estausFuscalizacionInput = new PadronAguaGeneralesInput();
            this.estausFuscalizacionInput.idAgua = this.id_agua;
            this.estausFiscalizacion = await this.padronAguaGeneralesService
              .getBusquedas(this.estausFuscalizacionInput)
              .toPromise();

            //===============================================================================
            //          Revisa si la cuenta tiene un proceso fiscal ya que no
            //         podra hacer cambios sobre esta cuenta
            //===============================================================================
            if (this.estausFiscalizacion.length != 0) {
              if (
                this.estausFiscalizacion[0].idEstatusFis == 1 ||
                (this.estausFiscalizacion[0].idEstatusFis == 3 &&
                  this.estausFiscalizacion[0].idTipoDocumento == 3)
              ) {
                this.consultaLectura = [];
                throw new Error(
                  "La cuenta: " +
                    this.estausFiscalizacion[0].cuentaAgua +
                    " tiene un proceso fiscal En Proceso."
                );
              }
            }
          } else {
            this.muestraMensaje.error(
              "No se encontro información para esta cuenta",
              "top",
              "center"
            );
          }
          //SI TIENE UN BLOQUEO VIGENTE NO PERIMITE AGREGAR PERIODOS
          if (aguas[0].bloqueoVigente) {
            this.correciones = false;
            this.bloqueoActivo = true;
            this.muestraMensaje.error("Cuenta bloqueada.", "top", "center");
          } else {
            this.bloqueoActivo = false;
          }
          //SI ES CUOTA FIJA ACTVA LA BANDERA PARA QUE NO SE PUEDAN MOVER LOS CONSUMOS
          if (aguas[0].tipoServicio == "CUOTA FIJA") {
            this.esCuotaFija = false;
          } else {
            this.esCuotaFija = false;
          }
          await this.columnasSimulacion();
          //Valdiar si es del modulo de modificacion de periodos
          //ya que si no le pude pegar a la captura y estatado de cuenta masivo
          debugger;
          buscaLectura.parametrosAdicionales = '{"soloVigentes": true }';
          await this.refrescar(buscaLectura);
          debugger;

          this.CapturaMasiva = false;
          this.guardar = true;
          //this.consultaLectura = null;

          await this.catTipoServiciosAll();
          await this.catDiametroTomasAll();
          await this.catTipoPeriodoAll();
          await this.catTipoIngresoAll();

        } else {
          this.showBar();
          this.columnas();
          this.simulacion = false;
          buscaLectura.id_usuario = this.usuario.id;
          this.esEstadoMasivo && this.childVencimientosLecturaComponent.checkedReimprimir? 
          buscaLectura.parametrosAdicionales = '{"historico": true, "fechaFacturacion": "' + this.formatarFecha(this.childVencimientosLecturaComponent.fechafac).toString() + '", "soloVigentes": true, "reimprimir": true }'
          : this.esEstadoMasivo ? buscaLectura.parametrosAdicionales = '{"historico": true, "fechaFacturacion": "' + this.formatarFecha(this.childVencimientosLecturaComponent.fechafac).toString() + '", "soloVigentes": true }'
          : buscaLectura.parametrosAdicionales = '{"historico": true, "fechaFacturacion": "' + this.formatarFecha(this.childVencimientosLecturaComponent.fechafac).toString() + '","soloVigentes": false }';


          //===============================================================================
          //          Hace la busqueda de las lecturas de captura masiva siempre
          //         y cuando se haya elegido un lecturista
          //===============================================================================
          const datoRetorno = await this.consultaLecturasService.getBusquedas(buscaLectura).toPromise();
          if (datoRetorno.length > 0) {
            this.progressBar = false;
            
            this.childVencimientosLecturaComponent.disabledCalcula = this.childVencimientosLecturaComponent.checkedReimprimir ? true : false;
            this.childVencimientosLecturaComponent.disabledImpRecepcion = this.childVencimientosLecturaComponent.checkedReimprimir ? true : false;
          } else {
            this.progressBar = false;
            this.messageService.add({severity: "warn", summary: "Sin Resultados", detail:"No existen resultados para esta combinación de búsqueda.",});
			      return;
          }

          this.zonaAguaId = buscaLectura.ruta;
          this.anio = datoRetorno[0].anio;
          this.periodo_parcialidad = datoRetorno[0].periodoParcialidad;
          this.id_usuario_lecturista = datoRetorno[0].idUsuarioLecturista;
          this.CapturaMasiva = true;
          this.guardar = true;
          this.consultaLectura = null;

          if(this.flagRecalcular) {
            datoRetorno.forEach(x => {
              x.validadoFacturacion = "VALIDADO";
            });
          }

          this.consultaLectura = datoRetorno;
          this.totalRegistro = this.consultaLectura.length
          this.consultaLectura.find((x) => x.idEstatus == 16) ? ( this.childVencimientosLecturaComponent.disabledImpRecibos = false, this.childVencimientosLecturaComponent.imprime = false ,  this.childVencimientosLecturaComponent.disabledImpRecepcion = false ) : (this.childVencimientosLecturaComponent.disabledImpRecibos = true, this.childVencimientosLecturaComponent.imprime = true, this.childVencimientosLecturaComponent.disabledImpRecepcion = true);
          this.consultaLectura.find((x) => x.idEstatus == 1) ? this.childVencimientosLecturaComponent.disabledImpRecibos = false  : false ;
          Object.keys(datoRetorno).length >0?this.buttonCritico = true: this.buttonCritico =false; // aparece boton de opciones 
          //this.idAgua = datoRetorno[0].idAgua;
          this.cAgua = datoRetorno[0].cuenta;
          for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
            this.consultaLectura[i].numRow = i;
            this.consultaLectura[i].anomalia = this.obtenerDescripcionAnomalia(this.consultaLectura[i].idAnomalia);
            this.consultaLectura[i].observacionCatalogo = this.obtenerDescripciobservacion(this.consultaLectura[i].idObservaciones);
            this.consultaLectura[i].tipoUso = this.obtenerDescripcionTipoUso(this.consultaLectura[i].idTipoUso);
            this.consultaLectura[i].uso = this.obtenerDescripcionUso(this.consultaLectura[i].idUso);
            this.consultaLectura[i].tipoServicio = this.obtenerDescripcionTipoServicio(this.consultaLectura[i].idTipoServicio);
            this.consultaLectura[i].tipoIngreso = this.obtenerDescripcionTipoIngreso(this.consultaLectura[i].idTipoIngreso);
            this.consultaLectura[i].estatus = this.obtenerDescripcionEstatus(this.consultaLectura[i].idEstatus);
            this.consultaLectura[i].usuarioLecturista= this.obtenerDescripcionLecturista(this.consultaLectura[i].idUsuarioLecturista);
            this.consultaLectura[i].fechaLecturaOutput= this.formatarFecha(this.consultaLectura[i].fechaLectura);
            this.clonedConsultaLecturas[this.consultaLectura[i].numRow] = {...this.consultaLectura[i],};
          }
          this.datosCargados.emit(this.totalRegistro);
          this.getCatAnomalias();
          this.getCatObservaciones();
          //} else {
          //    this.consultaLectura = null;
          //    throw new Error("Debe seleccionar un Lecturista.");
          //}
        }
      } else {
        this.consultaLectura = null;
      }
      //await this.consultaNoAdeudo();

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      this.consultaLectura = null;
    } finally {
      console.log("Paso por getLecturas");
      this.progressBar = false;
    }
  }

  async getAnios() {
			 
    try {
      const datoRetorno = await this.vencimientosLecturaService
        .getAll()
        .toPromise();

      datoRetorno.forEach((e) => {
        if (!this.nuevoAnio.find((x) => x.anio == e.anio)) {
          this.nuevoAnio.push(e);
        }
      });
      this.catalogoAnio = this.nuevoAnio;

      this.catalogoAnio.unshift({
        baja: false,
        cambio: false,
        id: null,
        idAguaZona: null,
        idTipoPeriodo: null,
        anio: null,
        periodoParcialidad: null,
        tomaLecturaIni: null,
        tomaLecturaFin: null,
        capturaIni: null,
        capturaFin: null,
        impresionIni: null,
        impresionFin: null,
        facturacionIni: null,
        facturacionFin: null,
        entregaIni: null,
        entregaFin: null,
        fechaVencimiento: null,
        fecha: null,
        numRow: null,
      });

      this.catalogoAnio.sort((x) => x.anio);
    } catch (ex) {
      if (ex.response) throw { message: ex.response.data };
      else throw ex;
    }
  }

  async getBimestres() {
			 
    try {
      const datoRetorno = await this.vencimientosLecturaService
        .getBimestres()
        .toPromise();

      datoRetorno.forEach((e) => {
        if (
          !this.nuevoBim.find(
            (x) => x.periodoParcialidad == e.periodoParcialidad
          )
        ) {
          this.nuevoBim.push(e);
        }
      });
     

      this.catalogoBimestres = this.nuevoBim;

      this.catalogoBimestres.unshift({
        baja: false,
        cambio: false,
        id: null,
        idAguaZona: null,
        idTipoPeriodo: null,
        anio: null,
        periodoParcialidad: null,
        tomaLecturaIni: null,
        tomaLecturaFin: null,
        capturaIni: null,
        capturaFin: null,
        impresionIni: null,
        impresionFin: null,
        facturacionIni: null,
        facturacionFin: null,
        entregaIni: null,
        entregaFin: null,
        fechaVencimiento: null,
        fecha: null,
        numRow: null,
      });
    } catch (ex) {
      if (ex.response) throw { message: ex.response.data };
      else throw ex;
    }
  }

  async getCatAnomalias() {
			 
    try {
      let datoRetorno = await this.catAnomaliasService.getAll().toPromise();

      //==========================================================================
      this.anomalias = datoRetorno.map((datos) => {
      // Convertir el string JSON a un objeto
      const jsonObject = JSON.parse(datos.dato);
      // Extraer el valor del atributo "id_ant"
        const idAnt = jsonObject.id_ant;
        var descripcion =idAnt+" "+datos.descripcion;
        return { label: descripcion, value: datos.id };
      });

      this.anomalias.unshift({ label: "SIN ANOMALIA...", value: 0 });

      // Ordenar las anomalías por el valor de 'value', tratando los valores como números
      this.anomalias.sort((a, b) => {
        return a.value - b.value;
      });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatAnomalias");
    }
  }

  async getCatObservaciones(){
      try{
        let datoRetorno = await this.observacionesDescripcion.getAll().toPromise();
      //==========================================================================
      this.descripcionObservacion = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.descripcionObservacion.unshift({ label: "SIN DESCRIPCION...", value: 0 });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatObservaciones");
    }
  }

  async validaAnio(anio) {
			 
    if (this.anioSeleccionadoIni.anio > this.anioSeleccionadoFin.anio) {
      this.muestraMensaje.error(
        "El año inicial no puede ser mayor al final.",
        "top",
        "center"
      );

      this.anioSeleccionadoFin = null;
      return;
    }
  }
  async validaBimestre(bimestre) {
			 
    if (
      this.anioSeleccionadoIni.anio == this.anioSeleccionadoFin.anio &&
      this.bimSeleccionadoIni > this.bimSeleccionadoFin
    ) {
      this.muestraMensaje.error(
        "El periodo inicial no puede ser mayor al final.",
        "top",
        "center"
      );

      this.bimSeleccionadoFin = null;
      return;
    }
  }

  async habilitaAnioFinal(anio) {
			 
    if (this.anioSeleccionadoIni) {
      this.confirmaAnio = true;
    }
  }

  async agregaPeriodos() {
			 
    //VALIDA QUE NINGUN PARAMETRO VALLA VACÍO
    if (
      !this.anioSeleccionadoFin ||
      !this.anioSeleccionadoIni ||
      !this.bimSeleccionadoFin ||
      !this.bimSeleccionadoIni
    ) {
      this.muestraMensaje.error(
        "Debes de seleccionar todos los rangos de fecha",
        "top",
        "center"
      );
      return;
    }
    //VALIDA QUE ER PERIODO INICIAL SEA MENOR AL FINAL
    if (
      this.anioSeleccionadoIni.anio +
        this.bimSeleccionadoIni.periodoParcialidad >
      this.anioSeleccionadoFin.anio + this.bimSeleccionadoFin.periodoParcialidad
    ) {
      this.muestraMensaje.error(
        "El periodo inicial no puede ser mayor al final.",
        "top",
        "center"
      );

      this.anioSeleccionadoFin = null;
      return;
    } else if (
      this.anioSeleccionadoIni.anio +
        this.bimSeleccionadoIni.periodoParcialidad ==
      this.anioSeleccionadoFin.anio + this.bimSeleccionadoFin.periodoParcialidad
    ) {
      this.muestraMensaje.error(
        "Los periodos no puedes ser iguales.",
        "top",
        "center"
      );

      this.anioSeleccionadoFin = null;
      this.bimSeleccionadoFin = null;
      return;
    }

    let difBimestres: number;
    difBimestres =
      (this.anioSeleccionadoFin.anio - this.anioSeleccionadoIni.anio) * 6 +
      (this.bimSeleccionadoFin.periodoParcialidad -
        this.bimSeleccionadoIni.periodoParcialidad);

    let periodosAsignados = Array<ConsultaLecturas>();
    let clonedConsultas: ConsultaLecturas[] = [];

    let periodoMaximo = this.bimSeleccionadoFin.periodoParcialidad;
    let clonedperiodoMaximo = periodoMaximo;
    let anioCalculado = this.anioSeleccionadoFin.anio;
    let difAnios =
      this.anioSeleccionadoFin.anio - this.anioSeleccionadoIni.anio;
    let serie = this.consultaLectura[0].serie;

    //GENERA ARREGLO CON LOS PERIODOS SELECCIONADOS


    //SE CREAN CLONES DE LAS VARIABLE THIS.CONSULTALECTURAS Y PERIODOSASIGNADOS
    clonedConsultas = this.consultaLectura;

    let insertaPeriodo = new ConsultaLecturas();

    let longitudT = 0;
    let longitudPeriodosAsignados = periodosAsignados.length - 1;

    if (this.consultaLectura) {
      longitudT = this.consultaLectura.length - 1;
    }

    let clonedPeriodosAsignados = Array<ConsultaLecturas>();

    //SE CLONA PERIODOSASIGNADOS A CLONEDPERIODOSASIGNADOS
    periodosAsignados.forEach((element) => {
      clonedPeriodosAsignados.push(element);
    });
    //REALIZA LA LIMPIEZA DE LOS PERIODOS CALCULADOS(SE COLOCA UN 0 EN AÑO CUANDO EL PERIODO YA EXISTE EN LA ENTIDAD DE LECTURAS)
    for (let x = 0; x <= longitudPeriodosAsignados; x++) {
      for (let j = 0; j <= longitudT; j++) {
        if (
          clonedPeriodosAsignados[x].periodoParcialidad ==
            clonedConsultas[j].periodoParcialidad &&
          clonedPeriodosAsignados[x].anio == clonedConsultas[j].anio
        ) {
          periodosAsignados[x].anio = 0;
        }
      }
    }
    //DESPUES DE HACER LA LIMPIEZA DE LOS PERIODOS, SE INSERTAN LOS PERIODOS QUE QUEDARON COMO RESULTADO DE LA LIMPIEZA
    for (let i = 0; i < periodosAsignados.length; i++) {
      if (periodosAsignados[i].anio != 0) {
        insertaPeriodo.anio = periodosAsignados[i].anio;
        insertaPeriodo.periodoParcialidad =
          periodosAsignados[i].periodoParcialidad;

        this.addNuevoConsumo(insertaPeriodo);
      }
    }

    this.display = false;

    this.ordenaPeriodos();
  }

  opcionesBotones() {
    //Opciones del menu
    this.esEstadoMasivo ?  
    this.itemsMenu = [
      { label: "Cargos Adicionales", icon: "pi pi-save" , command: (event) => { this.CargosAdicionales(); } } ,
      // { label: "Cargos Especiales", icon: "pi pi-save", command: (event) => { this.CargosEspeciales(); } }

    ] :
    this.itemsMenu = [
      {label: "Guardar", icon: "pi pi-save", command: (event) => { this.saveSimulacion = false; this.confirm(); }, title: "Guardar terminar",},
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.showBar(); this.refrescar(this.datosBusqueda); }, title: "Refrescar busqueda"},
      {label: "Critica", icon: "pi pi-tablet", command: (event) => { this.showBar(); this.imprimirCritical(); }, title: "Imprimir Critical"},
      {label: "ok", icon: "pi pi-check", command: (event) => { this.showBar(); this.vigenteMasivo(); }, title: "Establecer estatus en validado" },
      {label: "pro", icon: "pi pi-forward", command: (event) => { this.showBar(); this.procesoMasivo(); }, title: "Establecer estatus en proceso" },
      {label: "Imprimir", icon: "pi pi-print", command: (event) => { this.showBar(); this.imprimirLectura("pdf"); } , title: "Imprimir lectura" },
      {label: "Exportar", icon: "pi pi-file-excel", command: (event) => { this.showBar(); this.imprimirLectura("xlsx"); } , title: "Exportar Excel" }

    ];
  }

  async buscar() {
    let formulario = this.busquedaForm.value;

    this.opcionesBotones();
    
    try {
      this.consultaLecturasInput = new ConsultaLecturasInput();

      if (this.childVencimientosLecturaComponent.ruta) {
        this.consultaLecturasInput.ruta =
          this.childVencimientosLecturaComponent.ruta.id;
      }

      this.consultaLecturasInput.anioIn =
        this.childVencimientosLecturaComponent.anioSeleccionado.anio;
      this.consultaLecturasInput.periodo =
        this.childVencimientosLecturaComponent.bimestreSeleccionado.periodo;
      this.consultaLecturasInput.idAgua =
        this.childVencimientosLecturaComponent.cuenta;

      if (this.childVencimientosLecturaComponent.muestraUsuario == true) {
        this.consultaLecturasInput.lecturista =
          this.childVencimientosLecturaComponent.usuarioSeleccionado.id;
      } else {
        this.consultaLecturasInput.lecturista = null;
      }
      const datoRetorno = await this.consultaLecturasService
        .getBusquedas(this.consultaLecturasInput)
        .toPromise();
      this.lecturaTable = datoRetorno;

      this.consultaLectura = datoRetorno;
      this.cols = [
        { field: "colonia", header: "Colonia", width: "30%" },
        { field: "direccion", header: "Dirección", width: "40%" },
        { field: "cliente", header: "Cliente", width: "20%" },
        { field: "cuenta", header: "Cuenta", width: "10%" },
        { field: "lectura_fin", header: "Lectura Periodo", width: "10%" },
        { field: "id_anomalia", header: "Anomalia", width: "10%" },
      ];


      datoRetorno.forEach((datoRetorno) => {
        this.busquedaForm.patchValue({
          lectura_fin: datoRetorno.lecturaFin,  
          anomalia : this.obtenerDescripcionAnomalia(datoRetorno.idAnomalia),
          observacionCatalogo : this.obtenerDescripciobservacion(datoRetorno.idObservaciones),
          tipoUso : this.obtenerDescripcionTipoUso(datoRetorno.idTipoUso),
          tipoServicio : this.obtenerDescripcionTipoServicio(datoRetorno.idTipoServicio),
          tipoIngreso : this.obtenerDescripcionTipoIngreso(datoRetorno.idTipoIngreso),
          estatus : this.obtenerDescripcionEstatus(datoRetorno.idEstatus),
          usuarioLecturista: this.obtenerDescripcionLecturista(datoRetorno.idUsuarioLecturista),
          fechaLecturaOutput: this.formatarFecha(datoRetorno.fechaLectura)
        });
      });

      this.consultaLectura = datoRetorno;
      this.getCatObservaciones();
      this.getCatAnomalias();
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
  
      console.log("Paso por getLecturas");
    }
  }

  async actualizarLectura(lecturaActualizada: ConsultaLecturas[]) {
    try {
      this.showBar();
      this.json_lecturas = new json_lecturas();


      const datoRetorno = await this.actualizaLecturas
        .getBusquedas(this.json_lecturas)
        .toPromise();
      if (datoRetorno) {
        this.progressBar = false;
      }

      await this.muestraMensaje.notification(
        "Proceso Concluido.",
        "top",
        "center"
      );
      this.refrescar(this.datosBusqueda);
    } catch (e) {
      console.log(e);
      this.progressBar = false;
    }
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  onEditInit(event) {
			   
    let lecturaEdit = event.data;
    this.clonedConsultaLecturas[lecturaEdit.numRow] = { ...lecturaEdit };

    if (lecturaEdit.baja == true) {
      lecturaEdit.cambio = false;
      lecturaEdit.baja = true;
    } else {
      lecturaEdit.cambio = true;
      lecturaEdit.baja = false;
    }
  }

  // prettier-ignore
  onEditCancel(event) { 
    let consultaLecturasEdit = event.data;
    let index = this.consultaLectura.findIndex((obj) => obj.numRow === consultaLecturasEdit.numRow);
    this.consultaLectura[index] = { ...this.clonedConsultaLecturas[consultaLecturasEdit.numRow] };
  }

  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
    event.observaciones = null;
  }

  // prettier-ignore
  async onEditComplete(event) 
  {
    try {
        let consultaLecturasEdit = event.data;
        if (consultaLecturasEdit.periodoParcialidad <= 0 || consultaLecturasEdit.periodoParcialidad > 12) {
            this.muestraMensaje.error("El periodo de parcialidad debe de estar entre el bimestre 1 y bimestre 6.", "top", "center");
            consultaLecturasEdit.periodoParcialidad = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].periodoParcialidad;
            return;
        }
        if (consultaLecturasEdit.anio <= 0) {
            this.muestraMensaje.error("El año no puede ser menor o igual a 0.", "top", "center");
            consultaLecturasEdit.anio = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].anio;
            return;
        }
        //Valida si hay cambios
        if (
            consultaLecturasEdit.id === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].id &&
            consultaLecturasEdit.colonia === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].colonia &&
            consultaLecturasEdit.direccion === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].direccion &&
            consultaLecturasEdit.cliente === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].cliente &&
            consultaLecturasEdit.cuenta === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].cuenta &&
            consultaLecturasEdit.lecturaFin === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaFin &&
            consultaLecturasEdit.lecturaIni === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaIni &&
            consultaLecturasEdit.idAnomalia === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idAnomalia &&
            consultaLecturasEdit.serie === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].serie &&
            consultaLecturasEdit.idDiametroToma === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idDiametroToma &&
            consultaLecturasEdit.idTipoPeriodo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idTipoPeriodo &&
            consultaLecturasEdit.idTipoUso === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idTipoUso &&
            consultaLecturasEdit.idTipoIngreso === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idTipoIngreso &&
            consultaLecturasEdit.anio === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].anio &&
            consultaLecturasEdit.periodoParcialidad === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].periodoParcialidad &&
            consultaLecturasEdit.observaciones === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].observaciones &&
            consultaLecturasEdit.idUsuarioLecturista === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idUsuarioLecturista &&
            consultaLecturasEdit.idCobroConcepto === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idCobroConcepto &&
            consultaLecturasEdit.consumo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumo &&
            consultaLecturasEdit.idAgua === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idAgua &&
            consultaLecturasEdit.idTipoServicio === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idTipoServicio &&
            consultaLecturasEdit.idEstatus === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idEstatus &&
            consultaLecturasEdit.idMedidor === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idMedidor &&
            consultaLecturasEdit.idCargo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idCargo &&
            consultaLecturasEdit.baseConsumo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].baseConsumo &&
            consultaLecturasEdit.idBaseIva === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idBaseIva &&
            consultaLecturasEdit.baseIva === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].baseIva &&
            consultaLecturasEdit.idDrenaje === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idDrenaje &&
            consultaLecturasEdit.drenaje === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].drenaje &&
            consultaLecturasEdit.idDrenajeIva === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idDrenajeIva &&
            consultaLecturasEdit.drenajeIva === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].drenajeIva &&
            consultaLecturasEdit.idManejo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idManejo &&
            consultaLecturasEdit.manejo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].manejo &&
            consultaLecturasEdit.idManejoIva === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idManejoIva &&
            consultaLecturasEdit.manejoIva === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].manejoIva &&
            consultaLecturasEdit.idActualizacion === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idActualizacion &&
            consultaLecturasEdit.actualizacion === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].actualizacion &&
            consultaLecturasEdit.idRecargos === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idRecargos &&
            consultaLecturasEdit.recargos === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].recargos &&
            consultaLecturasEdit.cargoPendiente === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].cargoPendiente &&
            consultaLecturasEdit.idRedondeo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idRedondeo &&
            consultaLecturasEdit.redondeo === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].redondeo &&
            consultaLecturasEdit.total === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].total &&
            consultaLecturasEdit.descuento === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].descuento&&
            consultaLecturasEdit.consumoAnt === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumoAnt &&
            consultaLecturasEdit.consumoPu === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumoPu &&
            consultaLecturasEdit.consumoPr === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumoPr &&
            consultaLecturasEdit.consumoMin === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumoMin &&
            consultaLecturasEdit.consumoPerAnioAnt === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumoPerAnioAnt &&
            consultaLecturasEdit.fechaLectura === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].fechaLectura &&
            consultaLecturasEdit.m3Original === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].m3Original &&
            consultaLecturasEdit.validacion === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].validacion &&
            consultaLecturasEdit.fechaCritica === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].fechaCritica &&
            consultaLecturasEdit.lecturaCritica === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaCritica &&
            consultaLecturasEdit.idObservaciones === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idObservaciones 
          ) {
            let index = this.consultaLectura.findIndex((obj) => obj.numRow === consultaLecturasEdit.numRow);
            this.consultaLectura[index] = { ...this.clonedConsultaLecturas[consultaLecturasEdit.numRow] };
            return;
        }

        if (consultaLecturasEdit.baja == true) {
            consultaLecturasEdit.cambio = false;
            consultaLecturasEdit.baja = true;
            return;
        } else {
            consultaLecturasEdit.cambio = true;
            consultaLecturasEdit.baja = false;
        }


        //VALIDA SI UN PERIODO MODIFICADO YA EXISTE EN EL ARREGLO DE VALORES
        if (!this.CapturaMasiva) 
        {
            this.consultaLectura.forEach(element => {
                //========================================================================
                // REVISA SI YA EXISTE UN PERIODO ASIGNADO CON LA MISMA PARCIALIDAD Y AÑO
                //========================================================================
                if (element.anio == consultaLecturasEdit.anio && element.periodoParcialidad == consultaLecturasEdit.periodoParcialidad
                    && element.cambio == false) {
                    consultaLecturasEdit.anio = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].anio;
                    consultaLecturasEdit.periodoParcialidad = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].periodoParcialidad;
                    this.muestraMensaje.error("Ya existe un periodo asignado para este valor", "top", "center");
                    return;
                }
            });
        } else {
            //========================================================================
            // Inicia Captura Masiva
            //========================================================================
            if (consultaLecturasEdit.lecturaFin != 0 && consultaLecturasEdit.idTipoServicio == 1) {
                this.muestraMensaje.error("No puedes modificar la lectura de un predio de cuota fija.", "top", "center");
                consultaLecturasEdit.lecturaFin = 0;
                return;
            } else if (consultaLecturasEdit.lecturaFin != 0 && consultaLecturasEdit.idTipoServicio == 2) {
                this.muestraMensaje.error("No puedes modificar la lectura de un predio sin toma.", "top", "center");
                consultaLecturasEdit.lecturaFin = 0;
                return;
            }
        }


        // //SI ES MEDIDOR NUEVO LA LECTURA INICIAL SERÁ 0
        // if (consultaLecturasEdit.idAnomalia == 6) {
        //     consultaLecturasEdit.lecturaIni = 0;
        // }

        //SI SE AGREGA UNA ANOMALÍA DIFERENTE A MEDIDOR NUEVO LA LECTURA FINAL SERÁ DE 0
        // if (consultaLecturasEdit.idAnomalia != 0 && consultaLecturasEdit.idAnomalia != 6 && consultaLecturasEdit.idAnomalia != this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idAnomalia) {
        //     consultaLecturasEdit.lecturaFin = consultaLecturasEdit.lecturaIni;
        //     //consultaLecturasEdit.observaciones = null; Comentados por peticion de que no se borre nada
        // }

        if (consultaLecturasEdit.idAnomalia == 0 && this.clonedConsultaLecturas[consultaLecturasEdit.numRow].observaciones != null) {
            //consultaLecturasEdit.observaciones = null; Comentados por peticion de que no se borre nada
        }

        if (consultaLecturasEdit.idAnomalia != this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idAnomalia != consultaLecturasEdit.observaciones == null) {
            //consultaLecturasEdit.observaciones = null; Comentados por peticion de que no se borre nada
        }

        //VALIDA SI ES CAPTURA MASIVA
        if (this.CapturaMasiva == false) {
         
            //VALIDA QUE LAS LECTURAS INGRESADAS SEAN POSITIVAS O IGUAL A 0
            if (consultaLecturasEdit.lecturaFin < 0 || consultaLecturasEdit.lecturaIni < 0) {
                this.muestraMensaje.notification("No puedes ingresar lecturas negativas", "top", "center");
                consultaLecturasEdit.lecturaFin = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaFin;
                consultaLecturasEdit.lecturaIni = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaIni;
                consultaLecturasEdit.consumo = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].consumo;
                return;
            }
            //VALIDA SI ES UN NUEVO REGISTRO O UNO YA EXISTENTE
            if (this.clonedConsultaLecturas[consultaLecturasEdit.numRow].id == 0) {

                consultaLecturasEdit.consumo = consultaLecturasEdit.lecturaFin - consultaLecturasEdit.lecturaIni;
                //SI UNA DE LAS LECTURAS VA VACÍA ASIGAN UN 0 A L CONSUMO
                if (consultaLecturasEdit.lecturaFin == null || consultaLecturasEdit.lecturaIni == null) {
                    consultaLecturasEdit.consumo = 0
                }

            } else {
                // Ya existia el registro (No es nuevo)
                if (this.simulacion == false) {
                    //VALIDA LA LECTURA ANTERIOR CON UN +-10 %
                    let lecturaLimite = Math.round(consultaLecturasEdit.lecturaIni * 1.10);
                    let lecturaLimiteSoportado = Math.round(consultaLecturasEdit.lecturaIni * 1.15);

                }
               
                if(consultaLecturasEdit.lecturaFin !== this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaFin){
                    this.consultaLectura[consultaLecturasEdit.numRow].consumo = consultaLecturasEdit.lecturaFin - consultaLecturasEdit.lecturaIni;
                }
               
            }
        } else {
            //=====================================================================================================================
            //   INICIA Correcion de periodos y simulacion
            //=====================================================================================================================

            //VALIDA LA LECTURA ANTERIOR CON UN +-10 %
            let lecturaLimite = Math.round(consultaLecturasEdit.lecturaIni * 1.10);
            let lecturaLimiteSoportado = Math.round(consultaLecturasEdit.lecturaIni * 1.15);

            if (consultaLecturasEdit.lecturaFin == 0) {
                return;
            }

            if (consultaLecturasEdit.idAnomalia === this.clonedConsultaLecturas[consultaLecturasEdit.numRow].idAnomalia) {
                
                //VALIDA QUE LAS LECTURAS INGRESADAS SEAN POSITIVAS O IGUAL A 0
                if (consultaLecturasEdit.lecturaFin < 0) {
                  
                    this.muestraMensaje.notification("No puedes ingresar lecturas negativas", "top", "center");
                    consultaLecturasEdit.lecturaFin = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaFin;
                    return;
                } else if (consultaLecturasEdit.lecturaIni < 0) {
                    this.muestraMensaje.notification("No puedes ingresar lecturas negativas", "top", "center");
                    consultaLecturasEdit.lecturaIni = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaIni;
                    return;
                }

                //SI LA LECTURA INICIAL ES MAYOR A LA FINAL GENERA UNA ALERTA
                if (consultaLecturasEdit.lecturaIni > consultaLecturasEdit.lecturaFin) {
                    //consultaLecturasEdit.lecturaFin = this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaIni;
                    //this.muestraMensaje.notification("La lectura Actual no puede ser menor a la anterior : "  + this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaIni, "top", "center");
                }
                
                if(consultaLecturasEdit.lecturaFin !== this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaFin){
                  this.consultaLectura[consultaLecturasEdit.numRow].consumo = consultaLecturasEdit.lecturaFin - consultaLecturasEdit.lecturaIni;
                }
                
                //se comenta esta linea ya que no quieren que se la anomalia se actualiza el consumo y la lectura final
                //this.onChangeIdAnomalia(consultaLecturasEdit.idAnomalia , consultaLecturasEdit)   
                
                if(consultaLecturasEdit.lecturaFin !== this.clonedConsultaLecturas[consultaLecturasEdit.numRow].lecturaFin){
                  ///this.guardarGridLecturas()
                }
                  
              }
              
        }
    } catch (e) {
      throw e;
        this.muestraMensaje.error(e.message, "top", "center");
    } finally {
        console.log("Paso por onEditComplete");
    }
  }
  

  async add() {

    let siguienteParcialEnvia = new FCatVencimientosInput();
    siguienteParcialEnvia.IdAgua =  this.id_agua;
    let siguienteParcial = await this.fCatVencimientos.getBusquedas(siguienteParcialEnvia).toPromise();
    let aux = siguienteParcial.filter(x => x.anio == this.consultaLectura[0]?.anio && x.periodoParcialidad == this.consultaLectura[0]?.periodoParcialidad);
    
    
    let lecturaNew = new ConsultaLecturas();
    lecturaNew.cambio = true;
    lecturaNew.id = 0;
    lecturaNew.cuenta = this.cuentaSeleccionada.cuentaAgua;
    lecturaNew.derivada = this.cuentaSeleccionada.derivada;
    lecturaNew.idMedidor = this.consultaLectura[0]?.idMedidor;
    lecturaNew.idAgua = this.id_agua;
    lecturaNew.serie = this.consultaLectura[0]?.serie;
    lecturaNew.idTipoServicio = this.cuentaSeleccionada.idTipoServicio;
    lecturaNew.idTipoPeriodo = aux[0]?.idTipoPeriodo;
    lecturaNew.idDiametroToma = this.cuentaSeleccionada.idDiametroToma;
    lecturaNew.idTipoUso = this.consultaLectura[0]?.idTipoUso;
    lecturaNew.idAnomalia = 0;
    lecturaNew.lecturaFin = 0;
  									 
    if (this.consultaLectura[0] == null) {
        lecturaNew.lecturaIni = 0;
    } else {
				  
							
        this.consultaLectura.forEach((element) => {						   
            if (element.numRow == Math.min(...this.consultaLectura.map((o) => o.numRow), 0)) {
		   
                lecturaNew.lecturaIni = element.lecturaFin;
            }
        });
    }

    lecturaNew.consumo = 0;
    lecturaNew.direccion = "";

    if (this.simulacion) {
        lecturaNew.idEstatus = 3;
    } else {
        lecturaNew.idEstatus = 1;
    }
    lecturaNew.anio = aux[0]?.sigAnio;
    lecturaNew.periodoParcialidad = aux[0]?.sigPeriodoParcialidad;
    lecturaNew.lecturaIni =this.consultaLectura[0]?.lecturaFin;															
    lecturaNew.lecturaFin = 0;
    this.consultaLectura.unshift(lecturaNew);
    for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
              this.consultaLectura[i].numRow = i;
              this.consultaLectura[i].anomalia = this.obtenerDescripcionAnomalia(this.consultaLectura[i].idAnomalia);
              this.consultaLectura[i].observacionCatalogo = this.obtenerDescripciobservacion(this.consultaLectura[i].idObservaciones);
              this.consultaLectura[i].tipoUso = this.obtenerDescripcionTipoUso(this.consultaLectura[i].idTipoUso);
              this.consultaLectura[i].tipoServicio = this.obtenerDescripcionTipoServicio(this.consultaLectura[i].idTipoServicio);
              this.consultaLectura[i].tipoIngreso = this.obtenerDescripcionTipoIngreso(this.consultaLectura[i].idTipoIngreso);
              this.consultaLectura[i].estatus = this.obtenerDescripcionEstatus(this.consultaLectura[i].idEstatus);
              this.consultaLectura[i].usuarioLecturista= this.obtenerDescripcionLecturista(this.consultaLectura[i].idUsuarioLecturista);
              this.consultaLectura[i].fechaLecturaOutput= this.formatarFecha(this.consultaLectura[i].fechaLectura);
        this.consultaLectura[i].numRow = i;
        this.clonedConsultaLecturas[this.consultaLectura[i].numRow] = { ...this.consultaLectura[i] };	
    }
  }

  addNuevoConsumo(nuevoConsumo: ConsultaLecturas) {
			 
    let lecturaNew = new ConsultaLecturas();
    lecturaNew.cambio = true;
    lecturaNew.id = 0;
    lecturaNew.cuenta = this.cuentaSeleccionada.cuentaAgua;
    lecturaNew.derivada = this.cuentaSeleccionada.derivada;
    lecturaNew.idAgua = this.id_agua;
    //this.idAgua = lecturaNew.idAgua;
    lecturaNew.idTipoServicio = this.cuentaSeleccionada.idTipoServicio;
    lecturaNew.idTipoPeriodo = this.consultaLectura[0].idTipoPeriodo;
    lecturaNew.idDiametroToma = this.cuentaSeleccionada.idDiametroToma;
    lecturaNew.idTipoUso = this.cuentaSeleccionada.idTipoUso;
    lecturaNew.anio = nuevoConsumo.anio;
    lecturaNew.periodoParcialidad = nuevoConsumo.periodoParcialidad;
    lecturaNew.lecturaFin = 0;
    lecturaNew.lecturaIni = 0;
    lecturaNew.consumo = 0;
    lecturaNew.idAnomalia = 0;
    lecturaNew.serie = this.consultaLectura[0].serie;
    lecturaNew.observaciones ="Consumo Agregado Automaticamente Mediante la Simulación";
    lecturaNew.direccion = "";

    if (this.simulacion) {
      lecturaNew.idEstatus = 3;
    } else {
      lecturaNew.idEstatus = 1;
    }
    if (!this.consultaLectura) {
      this.consultaLectura = [];
      this.consultaLectura.unshift(lecturaNew);
    } else {
      this.consultaLectura.unshift(lecturaNew);
    }

    for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
      this.consultaLectura[i].numRow = i;
      this.clonedConsultaLecturas[this.consultaLectura[i].numRow] = {
        ...this.consultaLectura[i],
      };
    }
  }

  //===============================================================
  //Interaccion con servicios
  //===============================================================

  async guardarGridLecturasObservacion(validacionEstatus: boolean = true) {
    try{
      this.progressBar = true;
      //validacion que le pedi a luis, pero no se la agrego, esta es para estado de cuenta masivo
      if(this.consultaLectura != undefined) 
      {
        if(this.flagRecalcular) {
           this.consultaLectura.forEach(x => {
            x.validadoFacturacion = "VALIDADO";
            //x.idEstatus = 16;
          });
        }
        const today = new Date();
        const onlyDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        debugger;
        this.consultaLectura.forEach(x => {
          x.fechaemisi = this.childVenciminetoLectura.fechaemisi;
          x.fechavence = this.childVenciminetoLectura.fechavence;
         
          x.fechaImpresion  = onlyDate;
          x.idUsuarioImprimio = this.usuario;
          this.esEstadoMasivo && validacionEstatus ? x.idEstatus = 1 : null;
        });

        this.json_lecturas = new json_lecturas();

        this.json_lecturas.ConsultaLecturas = this.consultaLectura;
        this.json_lecturas.AplicaSimulacion = this.saveSimulacion;
        this.json_lecturas.id_usuario = this.usuario;
        this.json_lecturas.observacion_masiva = this.observacionMasivaTexto
       
    
  
        //=========================================================================================================================
        // Envía el grid con las lecturas modificadas para  guardar observaviones masivas 
        //=========================================================================================================================
          await this.actualizaLecturas.getBusquedas(this.json_lecturas).toPromise();

        //limpiar tabla
        this.esEstadoMasivo && validacionEstatus ? this.consultaLectura = [] : null;
        // borra ruta del select y limpia los demas campos
        validacionEstatus ? this.childVenciminetoLectura.borraFiltros() : null;

      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatMunicipios");
      this.progressBar = false;
    }
  }

  async guardarGridLecturas() {
    try {
      this.showBar();
      this.json_lecturas = new json_lecturas();
      
      for (let consultaLecturas of this.consultaLectura) {
        if ((consultaLecturas.anio == null || consultaLecturas.periodoParcialidad == null || consultaLecturas.lecturaIni == null || consultaLecturas.lecturaFin == null) && consultaLecturas.cambio == true) {
          this.muestraMensaje.error( "Ninguno de estos campos puede ir vacío (Año, Bimestre, Lectura Inicial o Lectura Final)", "top", "center");
          this.progressBar = false;
          this.refrescaValoresEstatus();
          return;
        }
        if (this.saveSimulacion == true) {
          //===============================================================================================================
          //  CAMBIA EL ESTATUS DE 3 (EN PROCESO) A 1 QUE ES VIGENTE
          //===============================================================================================================
          consultaLecturas.idEstatus = 1;
          if ((consultaLecturas.observaciones = "Consumo Simulado")) {
            consultaLecturas.observaciones = "";
          }
        }
        switch (consultaLecturas.idTipoUso) {
          case 7:
            consultaLecturas.idTipoUso = 1;
            break;
          case 2:
            consultaLecturas.idTipoUso = 2;
            break;
          case 4:
            consultaLecturas.idTipoUso = 3;
            break;
          case 8:
            consultaLecturas.idTipoUso = 9;
            break;
          case 5:
            consultaLecturas.idTipoUso = 10;
            break;
        }
      }

      ////////======================= ENVIA SOLO MODIFICADOS O DADOS DE BAJA
      let consultaLecturaNuevo: ConsultaLecturas[] = [];
      for (let lecturasFor of this.consultaLectura) { 
        
        if (lecturasFor.direccion) {
          lecturasFor.direccion = lecturasFor.direccion.replace("'", "");
        }

        if (lecturasFor.baja || lecturasFor.cambio) {
          
           if (lecturasFor.id == 0 && lecturasFor.idObservaciones == null && lecturasFor.baja == false) {
            this.muestraMensaje.error("Debes de agregar una observación al agregar un nuevo periodo.","top","center");
            this.progressBar = false;
            
            if(this.cambioEstatusMasivo){
              this.refrescaValoresEstatus();
            }
            
            return;
          }
          //SI SE QUITA UN PERIODO LANZA UNA ALERTA
          else if (lecturasFor.baja == true && lecturasFor.observaciones == null) {
            this.muestraMensaje.error("Debes agregar una observación cuando des de baja un periodo.","top","center");
            this.progressBar = false;
            
            if(this.cambioEstatusMasivo){
              this.refrescaValoresEstatus();
            }
            
            return;
          }
          //VALIDA QUE NO HAYA VALORES EN NEGATIVO
          // COMENTA EL SEÑOR DE DE MICRO QUE NO SE PUEDE VALIDAR LOS CONSUMOS EN NEGATIVO  NOTA POR ESO SE RETIRAESTA VALIDACION
          // else if (lecturasFor.consumo < 0 && this.simulacion == false) {
          //   this.muestraMensaje.error("No puedes agregar consumos en negativo, revisa los datos ingresados.","top","center");
          //   this.progressBar = false;

          //   if(this.cambioEstatusMasivo){
          //     this.refrescaValoresEstatus();
          //   }
            
          //   return;
          // }
          else {
            consultaLecturaNuevo.push(lecturasFor);
          }
        }
      }

      this.json_lecturas.ConsultaLecturas = consultaLecturaNuevo;
      this.json_lecturas.AplicaSimulacion = this.saveSimulacion;
      this.json_lecturas.id_usuario = this.usuario;
      this.json_lecturas.aplica_critica = this.aplicaCritica;
      
      //=========================================================================================================================
      // Envía el grid con las lecturas modificadas al controlador
      //=========================================================================================================================
      const datoRetorno = await this.actualizaLecturas.getBusquedas(this.json_lecturas).toPromise();

      if (datoRetorno) {
        this.progressBar = false;
        this.registroBitacora.idUsuario = this.usuario;
        await this.registroBitacoraService.add(this.registroBitacora).toPromise();
      }

      await this.muestraMensaje.notification("Proceso Concluido.","top","center");

      this.childBusquedaLectura(this.datosBusqueda)
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
      this.progressBar = false;
    } finally {
      console.log("Paso por guardarCatMunicipios");
    }
  }

  async ordenaPeriodos() {
			 
    let clonedConsultaLecturas: ConsultaLecturas[];
    clonedConsultaLecturas = this.consultaLectura;
    clonedConsultaLecturas.sort(function (a, b) {
      return (
        b.anio +
        b.periodoParcialidad / 100 -
        (a.anio + a.periodoParcialidad / 100)
      );
    });

  }

  async cambiaTipoServicio(event) {
    if (event.value) {
      this.consultaLectura.forEach((element) => {
        (element.idTipoServicio = event.value), (element.cambio = true);
      });
    }
  }

  async catTipoUsoAll() {
	
    const datoRetorno = await this.catTipoUsosService.getAll().toPromise();
    
    //para obtener los tipos de usos generales
    this.tipoUsos = datoRetorno
      .filter((datos) => [1, 2, 12].includes(datos.id))
      .map((datos) => {
        return { label: JSON.parse(datos.dato)?.uso_gral, value: datos.id };
      });
    this.tipoUsos.unshift({ label: "SELECCIONA...", value: null });

    //para obtener los usos
    datoRetorno.forEach( (datos) => {
      this.usos.push({ label: datos.id.toString() , value: datos.id });
    });

    // Ordenar la lista por el campo "label" (numéricamente o alfabéticamente)
    this.usos.sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));

    this.usos.unshift({ label: "SELECCIONA...", value: null });
  }

  async catTipoServiciosAll() {
    const datoRetorno = await this.catTipoServiciosService.getAll().toPromise();
    this.tipoServicio = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.tipoServicio.unshift({ label: "SELECCIONA...", value: null });
  }

  async catDiametroTomasAll() {
    const datoRetorno = await this.catDiametroTomasService.getAll().toPromise();
    this.diametroToma = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.diametroToma.unshift({ label: "SELECCIONA...", value: null });
  }

  async catTipoPeriodoAll() {	 
    const datoRetorno = await this.catTipoPeriodosService.getAll().toPromise();
    this.tipoPeriodo = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.tipoPeriodo.unshift({ label: "SELECCIONA...", value: null });
  }

  async catTipoIngresoAll() { 
    const datoRetorno = await this.catTipoIngresoService.getAll().toPromise();
    this.tipoIngreso = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.tipoIngreso.unshift({ label: "SELECCIONA...", value: null });
  }

  async catEstatusAll() { 
    const datoRetorno = await this.catEstatusService.getAll().toPromise();
    this.estatus = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.estatus.unshift({ label: "SELECCIONA...", value: null });
  }

  async catEstatusLecturista() {
    this.usuarios = new ObtenerUsuarioPorCargoInput();
    this.usuarios.idCargo = 1;
    this.usuarios.idEstatus = 1;

    const datoRetorno = await this.obtenerUsuarioPorCargoService
      .getBusquedas(this.usuarios)
      .toPromise();

    this.usuarioLecturista = datoRetorno.map((datos) => {
      return { label: datos.nombre, value: datos.id };
    });
    this.usuarioLecturista.unshift({ label: "SELECCIONA...", value: null });
   
  }

  async refrescar(buscaLectura: ConsultaLecturasInput) {
    try {
      //=========================================================================================================================
      // Limpia el grid en pantalla para evitar la posible duplicación de periodos
      //=========================================================================================================================
      this.consultaLectura = [];
      this.messageService.clear();
    
      this.totales = 0;
      buscaLectura.id_usuario = this.usuario;

      //     ____    _   _   ____     ___    _   _   _____   ____       _        ____    ___   __  __   _   _   _          _       ____   ___    ___    _   _   _____   ____
      //    | __ )  | | | | / ___|   / _ \  | | | | | ____| |  _ \     / \      / ___|  |_ _| |  \/  | | | | | | |        / \     / ___| |_ _|  / _ \  | \ | | | ____| / ___|
      //    |  _ \  | | | | \___ \  | | | | | | | | |  _|   | | | |   / _ \     \___ \   | |  | |\/| | | | | | | |       / _ \   | |      | |  | | | | |  \| | |  _|   \___ \
      //    | |_) | | |_| |  ___) | | |_| | | |_| | | |___  | |_| |  / ___ \     ___) |  | |  | |  | | | |_| | | |___   / ___ \  | |___   | |  | |_| | | |\  | | |___   ___) |
      //    |____/   \___/  |____/   \__\_\  \___/  |_____| |____/  /_/   \_\   |____/  |___| |_|  |_|  \___/  |_____| /_/   \_\  \____| |___|  \___/  |_| \_| |_____| |____/
      if (this.simulacion == true) {
        buscaLectura.estatus = 3;
        this.columnasSimulacion();
      } else {
        buscaLectura.estatus = 1;
        this.columnasCorreciones();
      }
      const retornoLecturas = await this.consultaLecturasService
        .getBusquedas(buscaLectura)
        .toPromise();
      if (retornoLecturas.length) {
            this.consultaLectura = retornoLecturas;
            for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
              this.consultaLectura[i].numRow = i;
              this.consultaLectura[i].anomalia = this.obtenerDescripcionAnomalia(this.consultaLectura[i].idAnomalia);
              this.consultaLectura[i].observacionCatalogo = this.obtenerDescripciobservacion(this.consultaLectura[i].idObservaciones);
              this.consultaLectura[i].tipoUso = this.obtenerDescripcionTipoUso(this.consultaLectura[i].idTipoUso);
              this.consultaLectura[i].tipoServicio = this.obtenerDescripcionTipoServicio(this.consultaLectura[i].idTipoServicio);
              this.consultaLectura[i].tipoIngreso = this.obtenerDescripcionTipoIngreso(this.consultaLectura[i].idTipoIngreso);
              this.consultaLectura[i].estatus = this.obtenerDescripcionEstatus(this.consultaLectura[i].idEstatus);
              this.consultaLectura[i].usuarioLecturista= this.obtenerDescripcionLecturista(this.consultaLectura[i].idUsuarioLecturista);
              this.consultaLectura[i].fechaLecturaOutput= this.formatarFecha(this.consultaLectura[i].fechaLectura);
            }
        //this.messageService.add({ severity: 'success', summary: 'Se encontró el registro.' });
      } else {
        //=========================================================================================
        // SI NO TIENE RESULTADOS Y ESTAMOS EN CORRECIÓN DE LECTURAS LIMPIA EL GRID
        // SI ES SIMULACION VUELVE A CONSULTAR PERO CON ESTATUS 1
        //=========================================================================================
        this.messageService.add({
          severity: "warn",
          summary: "Sin resultados.",
        });
        if (this.simulacion != true) {
          this.consultaLectura = [];
         
        }
      }
      this.progressBar = false;

      if (this.simulacion == true) {
        this.consultaLectura.forEach((element) => {
          element.cambio = true;
        });
        this.clear();

        if (retornoLecturas.length > 0) {
          this.messageService.add({
            severity: "success",
            summary: "Información encontrada",
            detail: "Se muestra datos de la simulación",
          });

          this.totales = 0;
          for (let lecturas of this.consultaLectura) {
            this.totales = this.totales + lecturas.total;
            lecturas.cambio = false;
          }
        } else {
          this.totales = 0;
          for (let lecturas of this.consultaLectura) {
            lecturas.cambio = true;
            lecturas.idEstatus = 3;
            lecturas.id = 0;
            lecturas.observaciones = "Consumo Simulado";

            this.totales = this.totales + lecturas.total;
          }
          this.messageService.add({
            severity: "warn",
            summary: "No existen datos de simulación",
            detail: "Se muestra información vigente",
          });
        }
      }
      //      ____    _   _   ____     ___    _   _   _____   ____       _         ____    ___    _   _   ____    _   _   __  __    ___    ____
      //     | __ )  | | | | / ___|   / _ \  | | | | | ____| |  _ \     / \       / ___|  / _ \  | \ | | / ___|  | | | | |  \/  |  / _ \  / ___|
      //     |  _ \  | | | | \___ \  | | | | | | | | |  _|   | | | |   / _ \     | |     | | | | |  \| | \___ \  | | | | | |\/| | | | | | \___ \
      //     | |_) | | |_| |  ___) | | |_| | | |_| | | |___  | |_| |  / ___ \    | |___  | |_| | | |\  |  ___) | | |_| | | |  | | | |_| |  ___) |
      //     |____/   \___/  |____/   \__\_\  \___/  |_____| |____/  /_/   \_\    \____|  \___/  |_| \_| |____/   \___/  |_|  |_|  \___/  |____/
      else if (this.simulacion == false && buscaLectura.idAgua) {
       
        buscaLectura.estatus = 1;
        this.id_agua = retornoLecturas[0].idAgua;
      }

      //    ____    _   _   ____     ___    _   _   _____   ____       _         ____      _      ____    _____   _   _   ____       _        __  __      _      ____    ___  __     __     _
      //   | __ )  | | | | / ___|   / _ \  | | | | | ____| |  _ \     / \       / ___|    / \    |  _ \  |_   _| | | | | |  _ \     / \      |  \/  |    / \    / ___|  |_ _| \ \   / /    / \
      //   |  _ \  | | | | \___ \  | | | | | | | | |  _|   | | | |   / _ \     | |       / _ \   | |_) |   | |   | | | | | |_) |   / _ \     | |\/| |   / _ \   \___ \   | |   \ \ / /    / _ \
      //   | |_) | | |_| |  ___) | | |_| | | |_| | | |___  | |_| |  / ___ \    | |___   / ___ \  |  __/    | |   | |_| | |  _ <   / ___ \    | |  | |  / ___ \   ___) |  | |    \ V /    / ___ \
      //   |____/   \___/  |____/   \__\_\  \___/  |_____| |____/  /_/   \_\    \____| /_/   \_\ |_|       |_|    \___/  |_| \_\ /_/   \_\   |_|  |_| /_/   \_\ |____/  |___|    \_/    /_/   \_\

      if (buscaLectura.idAgua == null) {
        this.columnas();
       

        if (buscaLectura.lecturista != null) {
          buscaLectura.id_usuario = this.usuario.id;
        
          this.CapturaMasiva = true;
          this.guardar = true;
          this.consultaLectura = null;
          this.consultaLectura = retornoLecturas;
        }
        this.id_agua = retornoLecturas[0].idAgua;
      }
      for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
        this.consultaLectura[i].numRow = i;
        this.clonedConsultaLecturas[this.consultaLectura[i].numRow] = {
          ...this.consultaLectura[i],
        };
      }
      this.getCatAnomalias();
      this.getCatObservaciones();


    } catch {
      this.progressBar = false;
    } finally {
      this.progressBar = false;
    }
  }

  async deleteLectura(lectura: ConsultaLecturas) {
			 
    try {
      const datoRetorno = await this.consultaLecturasService
        .delete(lectura.id)
        .toPromise();
      this.refrescar(this.datosBusqueda);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatMunicipios");
    }
  }
  async addLectura(lectura) {
			 
    if (lectura.idEstatus == null) {
      lectura.idEstatus = 1;
    }
    if (lectura.idAnomalia == 0 || lectura.idAnomalia == null) {
      lectura.idAnomalia = null;
    }
    try {
      const datoretorno = await this.consultaLecturasService
        .add(lectura)
        .toPromise();
      this.refrescar(this.datosBusqueda);
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatMunicipios");
    }
  }

  async recalcula(consumo: number) {
			 
    if (consumo <= 0 || consumo == null) {
      this.muestraMensaje.error("No puedes ingresar un valor menor a igual a 0.","top","center");
      return;
    }

    let primeraLectura = new ConsultaLecturas();
    primeraLectura = this.consultaLectura.filter( (x) => x.numRow == Math.max(...this.consultaLectura.map((o) => o.numRow), 0))[0];

    let recalculo = 0;
    let inicio = 0;
    let fin = consumo;

    // VALIDA QUE LA PRIMERA LECTURA DEL ARREGLO
    // SI ES 0 HARA LA DIVISION ENTRE EL CONSUMO INGRESADO Y LA LONGITUD DEL ARREGLO
    // SI ES DIFERENTE DE 0 SE HARA LA RESTA ENTRE EL CONSUMO INGRESADO Y LA LECTURA INICIAL ENTRE LA LONGITUD DEL ARREGLO
    if (primeraLectura.lecturaIni == 0) {
      recalculo = Math.round(consumo / this.consultaLectura.length);
    } else {
      if (primeraLectura.lecturaIni > consumo) {
        this.muestraMensaje.error("La lectura ingresada no puede ser menor a su primera lectura.","top","center");
        return;
      }
      recalculo = Math.round(
        (consumo - primeraLectura.lecturaIni) / this.consultaLectura.length
      );
      inicio = primeraLectura.lecturaIni;
    }

    // HACE LA ASIGNACIÓN DE VALORES EN EL ARREGLO DE LECTURAS
    this.consultaLectura
      .slice()
      .reverse()
      .forEach(function (element) {
        element.lecturaIni = inicio;
        element.lecturaFin = inicio + recalculo;
        element.consumo = recalculo;
        element.cambio = true;
        element.observaciones = "Consumo recalculado";
        inicio = inicio + recalculo;

        if (element.lecturaFin > fin) {
          element.lecturaFin =
            element.lecturaIni + (consumo - element.lecturaIni);
          element.consumo = element.lecturaFin - element.lecturaIni;
        }
      });

    let ultimaLectura = new ConsultaLecturas();
    ultimaLectura = this.consultaLectura.filter((x) => x.numRow == Math.min(...this.consultaLectura.map((o) => o.numRow), 0))[0];

    // VALIDA QUE LA ULTIMA LECTURA ASIGNADA SEA IGUAL AL CONSUMO INGRESADO
    if (ultimaLectura.lecturaFin < consumo) {
      ultimaLectura.lecturaFin = consumo;
      ultimaLectura.consumo = consumo - ultimaLectura.lecturaIni;
    }
  }

  async historicoMigracion() {
	
    this.showHistoricoMigracion();

    await this.consultaHistoricoMigradoInput$.emit(null);

    let buscaHistorico = new ConsultaHistoricoMigradoInput();
    buscaHistorico.cuenta = this.cuentaAgua;
    buscaHistorico.derivada = this.derivada;

    await this.consultaHistoricoMigradoInput$.emit(buscaHistorico);
  }

  async getAllConsumosCancelados() {
			 
    this.muestraHistoricoConsumos = true;
    try {
      this.columnasHistorico();

      let parametrosBusqueda = new HistoricoConsumosCanceladosInput();
      parametrosBusqueda.idAgua = this.id_agua;

      const datoRetorno = await this.historicoConsumosCanceladosService
        .getBusquedas(parametrosBusqueda)
        .toPromise();
      this.historicoConsumosCanceldos = datoRetorno;

    } catch (e) {
      console.log("Error: ", e.message);
    }
  }

  confirm() {
			 
    let i = 0;
    this.ContadorModificados = 0;
    for (let lecturas of this.consultaLectura) {
      if (lecturas.baja || lecturas.cambio) {
        i = i;
        i++;
        this.ContadorModificados = i;
      }
    }

    if (this.ContadorModificados <= this.consultaLectura.length) {
      this.ContadorNoModificados =
        this.consultaLectura.length - this.ContadorModificados;
      this.confirmationService.confirm({
        header: "Confirmación",
        message:
          "Faltan " +
          this.ContadorNoModificados.toString() +
          " cuentas por modificar, ¿Deseas aplicar los cambios?",
        accept: () => {
          this.guardarGridLecturas();
        },
      });
    } else {
      this.confirmationService.confirm({
        header: "Confirmación",
        message: "¿Deseas aplicar los cambios?",
        accept: () => {
          this.guardarGridLecturas();
        },
      });
    }
  }

  handleChange(e) {}
  clear() {
    this.messageService.clear();
    //this.consultaLectura = null;
  }
  
  onChangeIdAnomalia(id: any, renglon: any) {
      renglon.anomalia = this.obtenerDescripcionAnomalia(id); 
      this.aplicaReglasAnomalias(id, renglon);
  }	

  async aplicaReglasAnomalias(id: any, renglon: any) {
    debugger;
    console.log("entro a aplicaReglasAnomalias",renglon);
    
     if ([18].includes(id)) {
      renglon.validacion =  'M-M';
      console.log("entro a 18",renglon); 
      renglon.consumo =  Math.round(
        (renglon.lecturaFin / renglon.medidorDiasTrabajo) * renglon.diasPeriodo
      );
    }
    else if (renglon.derivada > 0 && renglon.idProrrateo === 3 ) {
      renglon.validacion = 'P';
    } else if(id === 6){
      
      renglon.validacion =  'D';
      
      let diferencia = renglon.lecturaFin - renglon.lecturaIni;
      
      if (diferencia < 9999 && renglon.lecturaIni < 9999) {
          renglon.consumo = ((diferencia) + 10000);
      } else if (diferencia < 99999 && renglon.lecturaIni < 99999) {
          renglon.consumo = ((diferencia) + 100000) ;
      } else if (diferencia < 999999 && renglon.lecturaIni < 999999) {
          renglon.consumo = ((diferencia) + 1000000) ;
      } else {
          renglon.consumo = diferencia;
      }
    }else if ([0, 18, 20, 23, 26, 25, 24, 1].includes(id)) {
        renglon.validacion =  'D';
        renglon.consumo = renglon.lecturaFin - renglon.lecturaIni;
    } else if ([7, 8, 13, 14, 17].includes(id) && (renglon.lecturaFin - renglon.lecturaIni) > 0) {
        renglon.validacion = 'D';
        renglon.consumo = renglon.lecturaFin - renglon.lecturaIni;
    } else if ([13].includes(id) && (renglon.lecturaFin === renglon.lecturaIni) ) {
        renglon.validacion = 'MA';
        renglon.consumo = renglon.consumoMin;
    } else if ([10, 11, 19].includes(id)) {
      renglon.validacion = 'MA';
      renglon.consumo = renglon.consumoMin;
    } else if (renglon.idTipoUso === 12 && renglon.idEstatusAgua === 1) {
        if (renglon.consumoPu >= renglon.consumoPr && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2, 7, 8, 14, 17].includes(id)) {
            renglon.validacion = 'PU';
            renglon.consumo = renglon.consumoPu;
        } else if (renglon.consumoPu <= renglon.consumoPr && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2, 7, 8, 14, 17].includes(id)) {
            renglon.validacion =  'PR';
            renglon.consumo = renglon.consumoPr;
        }
    } else if (renglon.idTipoUso === 12 && renglon.idEstatusAgua !== 1 && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2].includes(id)) {
        renglon.validacion =  'MA';
        renglon.consumo = renglon.consumoMin;
    } else if (renglon.idTipoUso  === 2 && renglon.idEstatusAgua === 1) {
        if (renglon.consumoPu > 0 && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2, 7, 8, 14, 17].includes(id)) {
            renglon.validacion =  'PU';
            renglon.consumo = renglon.consumoPu;
        } else if (renglon.consumoPr > 0 && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2, 7, 8, 14, 17].includes(id)) {
            renglon.validacion =  'PR';
            renglon.consumo = renglon.consumoPr;
        }
    } else if (renglon.idTipoUso  === 1 && renglon.idEstatusAgua === 1) {
        if (renglon.consumoPu > 0 && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2, 7, 8, 14, 17].includes(id)) {
            renglon.validacion =  'PU';
            renglon.consumo = renglon.consumoPu;
        } else if ([3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2, 7, 8, 13, 14, 17].includes(id)) {
            renglon.validacion =  'MA';
            renglon.consumo = renglon.consumoMin;
        }
    } 
    else if (renglon.idTipoUso === 12 && renglon.idEstatusAgua !== 1 && [3, 4, 5, 9, 12, 15, 16, 21, 22, 27, 2].includes(id)) {
        renglon.validacion =  'MA';
        renglon.consumo = renglon.consumoMin;
    } else {
        renglon.validacion =  'D'; // Valor por defecto
        renglon.consumo = renglon.lecturaFin - renglon.lecturaIni;
    }
    debugger;
    if (renglon.idTipoBloqueo && renglon.idTipoBloqueo !== 0) {
      if (!renglon.validacion.endsWith('-L')) {
        renglon.validacion += '-L';
    }
    }

    renglon.anomalia = this.obtenerDescripcionAnomalia(id);  
  }	

  obtenerDescripcionAnomalia(id: number): string {
			 
    if (!this.anomalias) return;
    const anomalia = this.anomalias.find((a) => a.value === id);
    return anomalia ? anomalia.label : "";
  }

  onChangeIdObservacion(id:any, renglon:any){
    renglon.idObservaciones=id;
    renglon.observacionCatalogo= this.obtenerDescripciobservacion(id);
  }
  
  obtenerDescripciobservacion(id: number): string {
			 
    if (!this.descripcionObservacion) return;
    const obtenerDescripciobservacion = this.descripcionObservacion.find((a) => a.value === id);
    return obtenerDescripciobservacion ? obtenerDescripciobservacion.label : "";
  }
									
  onChangeIdTipoUso(id: any, renglon: any) {
    renglon.tipoUso = this.obtenerDescripcionTipoUso(id);
  }														 

  obtenerDescripcionTipoUso(id: number): string {
    if (!this.tipoUsos) return;
    const tipoUsos = this.tipoUsos.find((a) => a.value === id);
    return tipoUsos ? tipoUsos.label : "";
  }

  obtenerDescripcionUso(id: number): string {
    if (!this.usos) return;
    const usos = this.usos.find((a) => a.value === id);
    return usos ? usos.label : "";
  }

  onChangeIdTipoServicio(id: any, renglon: any) {
    renglon.tipoServicio = this.obtenerDescripcionTipoServicio(id);
  }

  obtenerDescripcionTipoServicio(id: number): string {
			 
    if (!this.tipoServicio) return;
    const tipoServicio = this.tipoServicio.find((a) => a.value === id);
    return tipoServicio ? tipoServicio.label : "";
  }

  onChangeIdTipoIngreso(id: any, renglon: any) {
    renglon.tipoIngreso = this.obtenerDescripcionTipoIngreso(id);
  }												

  obtenerDescripcionTipoIngreso(id: number): string {
			 
    if (!this.tipoIngreso) return;
    const tipoIngreso = this.tipoIngreso.find((a) => a.value === id);
    return tipoIngreso ? tipoIngreso.label : "";
  }

  onChangeIdEstatus(id: any, renglon: any) {
    renglon.estatus = this.obtenerDescripcionEstatus(id);
  }
											
  obtenerDescripcionEstatus(id: number): string {
    if (!this.estatus) return;
    const estatus = this.estatus.find((a) => a.value === id);
    return estatus ? estatus.label : "";
  }

  onChangeIdUsuarioLecturista(id: any, renglon: any) {
    renglon.usuarioLecturista = this.obtenerDescripcionLecturista(id);
  }

  obtenerDescripcionLecturista(id: number): string {
			 
    if (!this.usuarioLecturista) return;
    const usuarioLecturista = this.usuarioLecturista.find(
      (a) => a.value === id
    );
    return usuarioLecturista ? usuarioLecturista.label : "";
  }

  getEstatusFiltrados() {
    this.estatusFiltrados = this.estatus.filter(
      (tipo) => tipo.label === "CAPTURADO" || tipo.label === "VALIDADO" || tipo.label === "EN PROCESO" || tipo.label === "SELECCIONA..."
    );
  }
			 
																												   
  async buscaLecturas(idAgua: number, cuenta: number) {
			 
    try {
      this.showLecturas();
      let buscaLecturas = new HistoricoLecturasInput();
      buscaLecturas.IdAgua = idAgua;
      buscaLecturas.CuentaAgua = Number(cuenta);
      buscaLecturas.IdAmbiente = this.iAmbiente;
      const datoRetorno = await this.historicoLecturasService
        .getBusquedasByInput(buscaLecturas)
        .toPromise();
      this.historicoLecturasInput = datoRetorno;
      this.historicoLecturasInput$.emit(this.historicoLecturasInput);
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    } finally {
      console.log("buscaLecturas");
    }
  }

  showDialog() {
			 
    this.display = true;
  }
  showHistoricoMigracion() {
			 
    this.displayHistoricoMigracion = true;
  }
  showLecturas() {
			 
    this.displayLecturas = true;
  }
  showBar() {
    this.critical = false;
    this.progressBar = true;
    //this.isPdfViewerVisible = this.critical || this.vallecturas;	
  }

  showCritical(){
			 
    this.critical = true; 
    this.isPdfViewerVisible = true

  }

  showValLecturas(){
    this.vallecturas = true;
    this.critical = false;
    //this.isPdfViewerVisible = this.critical || this.vallecturas;	
  }

  onChangefechaLectura(dato: any, renglon: any) {
    renglon.fechaLecturaOutput = this.formatarFecha(dato);

  }												 
														  
   formatarFecha(fechaInput: Date | string): string {
    if (!fechaInput) {
        return ''; 
    }

    // Convertir la entrada a un objeto Date
    let fechaObj: Date;
    if (typeof fechaInput === 'string') {
        // Si la cadena ya incluye una hora, se usa tal cual
        // Si no incluye una hora, se asume mediodía para evitar problemas con zonas horarias
        fechaObj = fechaInput.includes("T") ? new Date(fechaInput) : new Date(fechaInput + "T12:00:00");
    } else {
        fechaObj = fechaInput; // Aquí fechaInput es necesariamente un objeto Date
    }

    // Obtener los componentes de la fecha (día, mes, año) según la zona horaria local
    const dia = fechaObj.getDate();
    const mes = fechaObj.getMonth() + 1;
    const año = fechaObj.getFullYear();

    // Asegurarse de que el día y el mes tengan dos dígitos
    const diaStr = dia < 10 ? "0" + dia : "" + dia;
    const mesStr = mes < 10 ? "0" + mes : "" + mes;

    // Formatear la fecha en el formato dd-mm-yyyy
    return diaStr + "-" + mesStr + "-" + año;
  }

  async imprimirCritical() {
			 
    try {
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "lectura_critica";
      this.auxJasper.JasperReport.tipo = "pdf";

      // Configurar parámetros
      let _id_agua_zona = new ParametroJasper();
      _id_agua_zona.nombre = "_id_agua_zona";
      _id_agua_zona.valor = this.zonaAguaId + ""; 
      await this.auxJasper.ParametroJasper.push(_id_agua_zona);

      let _anio = new ParametroJasper();
      _anio.nombre = "_anio";
      _anio.valor = this.anio + ""; 
      await this.auxJasper.ParametroJasper.push(_anio);

      let _periodo_parcialidad = new ParametroJasper();
      _periodo_parcialidad.nombre = "_periodo_parcialidad"; 
      _periodo_parcialidad.valor = this.periodo_parcialidad  + ""; 
      await this.auxJasper.ParametroJasper.push(_periodo_parcialidad);
      
      let _id_usuario_lecturista = new ParametroJasper();
      _id_usuario_lecturista.nombre = "_id_usuario_lecturista"; 
      _id_usuario_lecturista.valor = this.id_usuario_lecturista  + ""; 
      await this.auxJasper.ParametroJasper.push(_id_usuario_lecturista);

      // Mostrar el diálogo o realizar la impresión
      this.showCritical();
     
    } catch (error) {
      console.error("Error al preparar el informe:", error);
      alert("No se pudo preparar el informe debido a un error.");
    }finally{
      console.log("Paso por imprimeSolicitud")
      this.progressBar = false;
    }
    
  }


  async aplicarCritica(event: ConsultaLecturas) {
    try {
        event.cambio = true;
        this.aplicaCritica = true;
       

        if (this.aplicaCritica = true) {

            let newCritica = new ConsultaLecturas();

            
            // se busca diferencias de hora para el nuevo proceso de critica
            let hoy =event.fechaCritica;
            let fechaLectura = event.fechaLectura;
              // Verifica si fechaLectura es una instancia de Date
            if (!(hoy instanceof Date)) {
                // Si no lo es, intenta convertirlo a una instancia de Date
                hoy = new Date(hoy);
            }
            if (!(fechaLectura instanceof Date)) {
                // Si no lo es, intenta convertirlo a una instancia de Date
              fechaLectura = new Date(fechaLectura);
            }
            const diferencia  = hoy.getTime() - fechaLectura.getTime();
            const dias = Math.floor(diferencia / (1000 * 3600 * 24));
            
            //if((event.lecturaCritica> 0 && event.idTipoPeriodo === 2 )|| (event.lecturaCritica>0 && event.idTipoPeriodo === 3)){ -- Cambio de variable ya esta vinene null y se toma idTipoPeriodo de la ruta
            if((event.lecturaCritica> 0 && this.id_tipo_periodo === 2 ) || (event.lecturaCritica> 0 && this.id_tipo_periodo === 3)){
              const lectAct = Math.round(((event.lecturaCritica - event.lecturaIni) / (60 + dias))*60+event.lecturaIni)
                      
              event.lecturaFin = lectAct;
            }

            //if(event.lecturaCritica>0 && event.idTipoPeriodo === 1){  -- Cambio de variable ya esta vinene null y se toma idTipoPeriodo de la ruta
            if(event.lecturaCritica>0 && this.id_tipo_periodo === 1){              
              const lectAct = Math.round(((event.lecturaCritica - event.lecturaIni) / (30 + dias))*30+event.lecturaIni)
              
              event.lecturaFin = lectAct;
            }

            for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
              if (this.consultaLectura[i] && this.consultaLectura[i].lecturaCritica != null && this.consultaLectura[i].cambio) {
                newCritica.lecturaFin = this.consultaLectura[i].lecturaFin;
                //this.consultaLectura[i].lecturaFin = this.consultaLectura[i].lecturaCritica;
                this.consultaLectura[i].consumo = this.consultaLectura[i].lecturaFin - this.consultaLectura[i].lecturaIni;
                await this.guardarGridLecturas();
              } 
            }
            
        } 
    } catch (error) {
        throw error;
    }
}

async negarAplicacionCritica(event) {
  try {
    this.aplicaCritica = false;
    await this.guardarGridLecturas();
  } catch (error) {
    throw error;
  }

}


async vigenteMasivo() {
  try {    
    let lectueasCheck = []
    this.cambioEstatusMasivo = true;
    for (let i = 0; i < this.consultaLectura.length; i++) {
      if (this.consultaLectura[i].check) {
        lectueasCheck.push(this.consultaLectura[i]);
      }

      if (this.consultaLectura[i].check && this.consultaLectura[i].idEstatus === 7) {
        this.consultaLectura[i].cambio = true;
        this.consultaLectura[i].idEstatus = 15;
        const today = new Date();
        const onlyDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.consultaLectura[i].fechaEnvio = onlyDate;
        this.consultaLectura[i].idUsuarioEnvio = this.usuario;
      }
    }

    if (lectueasCheck.length === 0) {
      this.muestraMensaje.error("Selecciona al menos una cuenta.", "top", "center");
      this.progressBar = false;
      return
    }
    
    await this.guardarGridLecturas();
  } catch (error) {
    console.error('Error en vigente Masivo:', error);
    throw error;
  }
}

async procesoMasivo() {
  try {
    let lectueasCheck = []
    this.cambioEstatusMasivo = true;
    for (let i = 0; i < this.consultaLectura.length; i++) {

      if (this.consultaLectura[i].check) {
        lectueasCheck.push(this.consultaLectura[i]);
      }

      if (this.consultaLectura[i].check && this.consultaLectura[i].idEstatus === 7) {
        this.consultaLectura[i].cambio = true;
        this.consultaLectura[i].idEstatus = 3;
      }
    }

    if (lectueasCheck.length === 0) {
      this.muestraMensaje.error("Selecciona al menos una cuenta.", "top", "center");
      this.progressBar = false;
      return
    }

    await this.guardarGridLecturas();
  } catch (error) {
    this.progressBar = false;
    //console.error('Error en procesoMasivo:', error);
    throw error;
  }
}

async onSelectAll(consultaLectura: any[]) {
  try {
    console.log("Paso por seleccionar todo", consultaLectura);
    if (consultaLectura == undefined || consultaLectura.length === 0) {
      throw new Error("Seleccionar una cuenta primero.");
    } else {
      if (this.numsRows.length === consultaLectura.length) {
        this.numsRows = [];
        this.consultaLectura.forEach(x => { x.check = false });
      } else {
        consultaLectura.forEach(x => { x.check = true });
        let filteredArray = this.consultaLectura.filter(item1 =>
          consultaLectura.some(item2 => item1.id === item2.id)
        );
        filteredArray.forEach(filteredItem => {
          let correspondingItem = this.consultaLectura.find(item => item.id === filteredItem.id);
          correspondingItem.check = true; // Cambia la propiedad 'check' al valor deseado
        });
        this.numsRows = consultaLectura.map(renglon => renglon);
      }
    }
  } catch (e) {
    this.muestraMensaje.error(e.message, "top", "center");
  } finally {
    console.log("Paso por seleccionar todo");
  }
}

async onRowSelect(event: any, renglon: any) {
  if (event.target.checked) {
    renglon.check = true;
    this.numsRows.push(renglon);
  } else {
      const index = this.numsRows.indexOf(renglon);
      if (index !== -1) {
        this.numsRows.splice(index, 1);
        renglon.check = false;
      
    }
  }
}


async isRowSelected(renglon: any): Promise<boolean> {

  return this.numsRows.includes(renglon);
}

async agregaCargos(event) {
  try{
    this.consultaLecturaRow  = [];
    this.consultaLecturaRow.push(event);
    this.cargosDialog = true;
    event.check = true;
    this.chilCargoDetallesGridComponent.cambioSelect(this.consultaLecturaRow, this.consultaLectura,  false);
  } catch (error) {
    throw error;
  } finally {
    console.log("Paso por agregaCargos");
  }
}

async CargosAdicionales(){
  try{
    this.consultaLecturaFlag = true;
    this.consultaLecturaRow  = [];
    this.consultaLecturaRow = this.consultaLectura;
    this.cargosDialog = true;

    this.chilCargoDetallesGridComponent.cambioSelect(this.consultaLecturaRow, this.consultaLectura,  true);
  } catch (error) {
    throw error;
  } finally {
    console.log("Paso por CargosAdicionales");
  }
}
async CargosEspeciales(){
  try{
    this.consultaLecturaFlag = true;
    this.consultaLecturaRow  = [];
    this.consultaLecturaRow = this.consultaLectura;
    this.cargosDialogEspecial = true;
    this.consultaLecturasOutput.emit(this.consultaLectura);
   
  } catch (error) {
    throw error;
  } finally {
    console.log("Paso por CargosAdicionales");
  }
}

async childcargoDetalles(cargos: ConsultaLecturas[]) {
  try {
    //Actualizamos todo el registro
    cargos.forEach(x => {
      x.checkCargos = true;
      let index = this.consultaLectura.findIndex((obj) => obj.id === x.id);
      this.consultaLectura[index] = x;
    });
    this.tamanio =  Object.keys(this.consultaLectura.filter((x) => x.checkCargos)).length;
    
  } catch (e) {
    this.muestraMensaje.error(e.message, "top", "center");
  } finally {
    console.log("Paso por childAguas");
  }
}

async imprimirRecepcion(estadoCuentaInformacionInput: ConsultaLecturasInput){
  this.ImprimeRecepcionEmit.emit(estadoCuentaInformacionInput);
}

async imprimeResibos(estadoCuentaInformacionInput: ConsultaLecturasInput){
  this.ImprimeRecibosEmit.emit(estadoCuentaInformacionInput);

}

async muestraImagenes(renglon ){
  try {
    this.imagenes = null;
    this.progressBar = this.imageDialog =  true;
    const datoRetorno = await this.muestraImageneservice
    .getSingle(renglon?.cuenta, renglon?.periodoParcialidad,  renglon?.anio.toString()  )
    .toPromise();

    if(datoRetorno == null)
    {
      this.muestraMensaje.error("No se encontraron imagenes.", "top", "center");
      this.imageDialog =  false;
    }
    else 
    {
      this.imagenes = datoRetorno;
    }

  } catch (e) {
    this.muestraMensaje.error(e.message, "top", "center");
  } finally {
    console.log("Paso por muestraImagenes");
    this.progressBar = false;
  }
}

async childflagRecalcular(event){
  try {
    this.flagRecalcular = event;

    } catch (e) {
    this.muestraMensaje.error(e.message, "top", "center");
  } finally {
    console.log("Paso por childflagRecalcular");
  }
}

async imprimirLectura(tipoArchivo: string) {
  try {
    this.auxJasper = new AuxJasper();

    // selecccion del reporte a imprimir
    this.auxJasper.JasperReport.tipo = tipoArchivo;
    if(tipoArchivo === 'pdf'){
      this.auxJasper.JasperReport.nombreReporte = "validacion_lecturas";
      this.showValLecturas(); 
      this.isPdfViewerVisible = true; 
    }else {
      this.auxJasper.JasperReport.nombreReporte = "validacion_lecturas_excel";
      this.isPdfViewerVisible = false; 
    }   
    
    // Configurar parámetros
    let _id_agua_zona = new ParametroJasper();
    _id_agua_zona.nombre = "_id_agua_zona";
    _id_agua_zona.valor = this.zonaAguaId + "";
    this.auxJasper.ParametroJasper.push(_id_agua_zona);

    let _anio = new ParametroJasper();
    _anio.nombre = "_anio";
    _anio.valor = this.anio + "";
    this.auxJasper.ParametroJasper.push(_anio);

    let _periodo_parcialidad = new ParametroJasper();
    _periodo_parcialidad.nombre = "_periodo_parcialidad";
    _periodo_parcialidad.valor = this.periodo_parcialidad + "";
    this.auxJasper.ParametroJasper.push(_periodo_parcialidad);
    
    
  } catch (error) {
    console.error("Error al preparar el informe:", error);
    alert("No se pudo preparar el informe debido a un error.");
  } finally {
    console.log("Paso por imprimirLectura");
    this.progressBar = false;
  }
}


  async cerrarRutaEvento(event) {
    this.cerrarRutaEdicion = event;
    this.itemsMenu = [];
  }

  getRowClass(detalle: any): string {

    //console.log("aqui andamos", detalle);
    if (detalle.idEstatus === 7) {
      return '#f4d03f';
    }else  if (detalle.idEstatus === 3) {
      return '#f5b041'
    }else {
      return '#27ae60'; // No hay color especificado
    }
  }

  async FcalcularOutput(event: ConsultaLecturasInput) {
    await this.calculaLecturasOutput.emit(event);
  }
  
  //devuelve solo los valores del atributo idEstatus  originales de consultaLectura con clonedConsultaLecturas
  refrescaValoresEstatus(){
    for (let i = 0, len = this.consultaLectura.length; i < len; ++i) {
      this.consultaLectura[i].idEstatus = this.clonedConsultaLecturas[i].idEstatus;
      this.consultaLectura[i].cambio = false;
      this.consultaLectura[i].check = false;
    }
    this.cambioEstatusMasivo = false;
  }

  emiteProgresBar(event: boolean) {
    this.progressBar = event;
  }

  emiteDesabledBotton(event: boolean) {
    this.disabledBotton = event;
  }
  // se agrega proceso para guardar la critica fecha y lecturista masiva 
  async guardarCritica(){
    try {
      debugger;
      let lectueasCheck = []
      this.cambioEstatusMasivo = true;
      for (let i = 0; i < this.consultaLectura.length; i++) {
  
        if (this.consultaLectura[i].check && this.consultaLectura[i].idEstatus === 3) {
          this.consultaLectura[i].fechaCritica = this.fechaCritica;
          this.consultaLectura[i].idUsuarioLecturista = this.idUsuarioLecturista;
          lectueasCheck.push(this.consultaLectura[i]);
        }
  
      }
  
      if (lectueasCheck.length === 0) {
        this.muestraMensaje.error("Selecciona al menos una cuenta.", "top", "center");
        this.progressBar = false;
        return
      }
  
      await this.guardarGridLecturas();
    } catch (error) {
      this.progressBar = false;
      //console.error('Error en procesoMasivo:', error);
      throw error;
    }


  }

}



